
function changeVisu(field, path, evt) {
    var new_img, target, current;

    // field : id (PDP, legacy) ou élément DOM déjà résolu (rayon, cf. onItemColorChange)
    field = (typeof field === 'string') ? document.getElementById(field) : field;

    if (evt) {
        target = evt.target.parentElement;
        current = target.parentElement.getElementsByClassName("current");

        target.classList.add("current");

        Array.prototype.slice.call(current).forEach(function (elm) {
            if (elm !== target) {
                elm.classList.remove("current");
            }
        });
    }

    if (field && field.parentElement) {
        // <picture><source srcset>: le <source> prime sur l'<img src>, il faut le retirer
        // sinon le navigateur ignore l'image de la couleur sélectionnée.
        if (field.parentElement.tagName === 'PICTURE') {
            $(field).siblings('source').remove();
        }

        new_img = new Image();

        new_img.id = field.id;
        new_img.className = field.className;

        new_img.addEventListener("load", function () {
            this.alt = field.alt;

            this.setAttribute("width", this.naturalWidth);
            this.setAttribute("height", this.naturalHeight);

            if (field.parentElement) {
                field.parentElement.appendChild(this);
                field.parentElement.removeChild(field);
            }
        });

        new_img.src = path;
    }
}

function changeLocale(locale, uri, redirect = true, siteId = 0) {
    $.ajax({
        url: path_relative_root + "ajax_get_uri_by_lang.php",
        type: "post",
        data: {lang: locale, url: uri, redirect: redirect, site: siteId},
        success: function (data) {
            if (data != "") {
                var force = "";
                if (uri == "/") {
                    force = "?force";
                }
                if (redirect) {
                    location.href = data + force;
                } else {
                    urlLang = data;
                }
            }
        },
    });
}

function zoomImg(slide) {
    var deferredPlayers = $("#zoomBox .player-container-dailymotion-deferred");

    if (deferredPlayers.length && typeof initDailymotionVideos === "function") {
        deferredPlayers.removeClass("player-container-dailymotion-deferred").addClass("player-container-dailymotion");
        initDailymotionVideos();
    }

    $(".zoom_main_wrapper").css("opacity", 0);

    window.setTimeout(function () {
        new Swiper("#thumbs_scroller", {
            slidesPerView: 1,
            watchSlidesProgress: true,
            initialSlide: slide - 1,
            navigation: {
                nextEl: ".thumbsNext",
                prevEl: ".thumbsPrev",
            },
        });
    }, 100);

    window.setTimeout(function () {
        $(".zoom_main_wrapper").animate({ opacity: 1 }, 650);
    }, 750);

    openMultiShad("zoomBox");
    $("#shad").addClass("actif");

    if ($("#shad").hasClass("actif")) {
        $("#shad").on("click", function () {
            closeMultiShad("zoomBox");
        });
    }

    // Hidde overflow to prevent double scroll on page on zoom
    if ($("body.product_page").length) {
        if ($("#zoomBox").hasClass("actif")) {
            $("body.product_page").toggleClass("no_hoverflow");
        }
        $("#shad").on("click", function () {
            $("body.product_page").removeClass("no_hoverflow");
        });
    }
}

/*
 * Display sizes dropdown on "select a size" FP button
 * */
$(document).on("click touch", "#fpWrapperBtn.noSize", function () {
    $("#ligne_pointure").click();
});

/*
 * Add loader on basket rollover btn
 * */
$(document).on("click touch", ".wrap_tot_panier .button", function () {
    $(this).next(".loader").addClass("loading");
});

/**
 * Peremt de récupérer les stocks des tailles par couleur ainsi que leur stock
 * @author Timothy Beard / Aurélien Renault
 * @since  2017-09-27
 */
function setAvailableSizes() {
    var produit_id = $('#produit_principal').val();
    var data = {produit_id: new Array(produit_id)};

    if (isGlobalEActive) {
        data.warehouse_only = 1;
    }

    var elem_id = $(this).val();

    $.ajax({
        url: path_relative_root + 'ajax_get_colisages_states_by_color_size.php',
        type: 'post',
        data: data,
        success: function (res) {
            try {
                res = $.parseJSON(res);
            } catch (e) {
                console.error("parseJSON");

                return;
            }

            if (res.success && res.result && res.result[produit_id] != undefined && res.result[produit_id][elem_id] != undefined) {
                var sizes_tab = res.result[produit_id][elem_id];
                var size_box, is_disabled;

                for (size_id in sizes_tab) {
                    if (sizes_tab.hasOwnProperty(size_id)) {
                        $("#btn_resa_shop").show();
                        $("#bloc_add_alert").hide();
                        size_box = $('.product_main_wrapper [name="itm_size"]').filter(
                            '[value="' + size_id + '"]'
                        );
                        is_disabled = !sizes_tab[size_id];
                        if (is_disabled) {
                            size_box.addClass("disabled");
                        } else {
                            size_box.removeClass("disabled");
                        }
                    } else {
                        $("#btn_resa_shop").hide();
                        $("#bloc_add_alert").show();
                    }
                }
            }
        }
    });
}

// permet de faire clignoter si la taille n'as pas etait choisi
function FaireClignoterImage() {
    $("#ligne_pointure").addClass("image-clignote");
    window.setTimeout(function () {
        $("#ligne_pointure").removeClass("image-clignote");
        $("#ligne_pointure").addClass("actif");
        $("#ligne_pointure .choices_list").addClass("opened");
    }, 2000);
}

function closeSearch() {
    $(".wrap_search_field").fadeOut();
    $("body").removeClass("search");
    $("#trigger_recherche").css("opacity", "1");
    $("#shad_menu").removeClass("actif");
    if ($(window).scrollTop() <= 0) {
        $("#site_head_wrap").removeClass("sticky");
    }
}

function closeSearchRecap() {
    let input_search = document.getElementById("search_home");

    input_search.value = "";
    input_search.focus();
}

function searchCategoryFilter() {
    // for each .sub_cat_name, check if it has the .current class, if so, save its index to use as the initial slide
    let currentSlide = 0;
    $(".sub_cat_name").each(function (index) {
        if ($(this).hasClass("current")) {
            currentSlide = index;
        }
    });

    var catFilterSwiper = new Swiper(".sub_categ_wrapper #slideCateg", {
        roundLengths: true,
        slidesPerView: "auto",
        initialSlide: currentSlide,
        slidesOffsetBefore: 20,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });
}

// Triggered from APP on search end, V2
function triggerFunctionOnSearchEnd() {
    // When no results are found
    if($('.no_results_wrapper').length) {
        setTimeout(() => {
            // Init TG swipper
            let tgSwiper = new Swiper(".no_results_wrapper .tg-module .slider", {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 15,
                observeParents: true,
                observer: true,
                uniqueNavElements: false,
                watchSlidesProgress: true,
                pagination: {
                    el: ".tg-module-pagination",
                    clickable: true,
                    type: "bullets",
                },
                breakpoints: {
                    1025: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                },
            });

            initializeItemSliders();

            lazyImageLoader(); // custom image lazyloading function
        }, 0);
    }
}

$(function () {
    /**
     * Select current page in menu
     */
    var selectedElement = document.querySelector('[data-path="' + currentPath + '"]');
    if (currentPath != "" && selectedElement) {
        if (selectedElement.classList.contains('.supercateg_item')) {
            selectedElement.querySelector('.menu_supercateg').classList.add('current');
        } else {
            if (selectedElement.closest('.menu_sscateg')) {
                selectedElement.closest('.menu_sscateg').parentElement.classList.add('current');
                selectedElement.closest('.menu_sscateg').classList.add('current');
            }
            selectedElement.closest('.supercateg_item').querySelector('.menu_supercateg').classList.add('current');
        }
    }

    if ($("body.giftcard_index").length) {
        window.setTimeout(function () {
            $("#site_global_wrap").addClass("appear");
        }, 500);
    }

    setTimeout(function () {
        $(document).on("click", ".cart_product_modify .basketToWishlist", function () {
            $(".cart_product_modify .basketToWishlist").addClass("clicked");
        });
    }, 500);

    $(document).on("click touch", ".js-close-filter", function () {
        $("#rayon_sticky_block, .rayon_sticky_block, .dynasearchwrapper #rayon_sticky_block").removeClass("show");
        $("#trigger_filtre, .dynasearchwrapper #trigger_filtre").removeClass("triggered");
        $(".shad").removeClass("actif");
    });

    $("#theme_global .theme").on("click", function () {
        $("html, body").animate({ scrollTop: 400 }, 500);
        $(".reassurance").addClass("changeBottom");
    });

    $(document).on("click", "#addToWishlistButton", function () {
        if ($("#bloc_availability").hasClass("inactiv")) {
            FaireClignoterImage();
        }
    });

    $("#bloc_availability").on("click", function () {
        if ($("#bloc_availability").hasClass("inactiv")) {
            FaireClignoterImage();
        }
    });

    $(".characts_8").on("hover", function () {
        $(".attribute_8").toggleClass("active");
    });
    $(".characts_9").on("hover", function () {
        $(".attribute_9").toggleClass("active");
    });
    $(".characts_10").on("hover", function () {
        $(".attribute_10").toggleClass("active");
    });
    $(".characts_11").on("hover", function () {
        $(".attribute_11").toggleClass("active");
    });
    $(".characts_12").on("hover", function () {
        $(".attribute_12").toggleClass("active");
    });
    $(".characts_13").on("hover", function () {
        $(".attribute_13").toggleClass("active");
    });

    $(".w-input-element").on("click", function () {
        $(this).removeClass("inputErr");
    });

    if ($(".promo_swiper .swiper-slide").length > 0) {
        promoSwiper = new Swiper(".promo_swiper", {
            centeredSlides: true,
            loop: true,
            slidesPerView: "auto",
            speed: 1500,
        });
    }

    if ($("#slideCateg .swiper-slide").length) {
        searchCategoryFilter();
    }

    $("#trigger_recherche").on("click touch", function () {
        $(".wrap_search_field").fadeIn();
        $("body").addClass("search");
        $("#site_head_wrap").addClass("sticky");
        $("#trigger_recherche").css("opacity", "0");
        $("#shad_menu").addClass("actif");
    });

    $(".close_search").on("click", function () {
        let input_search = document.getElementById("search_home");

        if (input_search.value === "") {
            closeSearch();
        } else {
            input_search.value = "";
            input_search.focus();
        }

        if ($(window).scrollTop() <= 0) {
            $("#site_head_wrap").removeClass("sticky");
        }
    });

    $("#shad_menu").on("click", function () {
        $(".wrap_search_field").fadeOut();
        $("body").removeClass("search");
        $("#trigger_recherche").css("opacity", "1");
        $("#shad_menu").removeClass("actif");
        if ($(window).scrollTop() <= 0) {
            $("#site_head_wrap").removeClass("sticky");
        }
    });

    /**
     * Back to top event
     */
    backToTop = function () {
        var scrollTrigger = 100;
        var scrollTop = $(window).scrollTop();
        var copyrightHeight = $("#copyright").innerHeight();
        var copyrightOffset = $("#copyright").offset();

        var categoryPage = $("body.category");

        if (categoryPage.length) {
            if (
                scrollTop > scrollTrigger &&
                scrollTop < copyrightOffset.top - copyrightHeight
            ) {
                $("#scroll_to_top").addClass("show");
            } else {
                $("#scroll_to_top").removeClass("show");
            }
        }
    };

    backToTop();

    $(window).on("scroll", function () {
        backToTop();
    });

    $("#scroll_to_top").on("click", function (e) {
        e.preventDefault();
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            700
        );
    });

    if ($(".cartAssociations").length) {
        updateCartElements();
    }

    moveProductOutOfStock();

    new Swiper("#sliderHomeInsta", {
        slideToClickedSlide: true,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next.instaNext",
            prevEl: ".swiper-button-prev.instaPrev",
        },
    });

    /**
     * Category SEO txt read more
     */
    if ($(".txt.trimed").length) {
        var trimedTxt = $(".txt.trimed");
        var read_more = $(".read_more");
        var read_less = $(".read_less");
        var heightToToggle = trimedTxt.height();
        trimedTxt.css("height", "75px");
        read_more.on("click", function () {
            trimedTxt.addClass("cache");
            trimedTxt.animate({ height: heightToToggle + 40 }, 500);
            read_more.addClass("cache");
            read_less.removeClass("cache");
        });
        read_less.on("click", function () {
            trimedTxt.removeClass("cache");
            trimedTxt.animate({ height: "75px" }, 500);
            read_more.removeClass("cache");
            read_less.addClass("cache");
        });
    }

    if ($(".videos-module .swiper").length) {
        new Swiper(".videos-module .swiper", {
            pagination: {
                el: ".videos-module-pagination",
                type: "bullets",
                clickable: true,
            },
        });
    }

    $(".date_filter_title").on("click", function () {
        $("#date_filter_wrapper").slideToggle();
    });

    $(".block-btn-filter .button").on("click", function () {
        $(this).next().addClass('loading');
        setTimeout(function () {
            $('.loader').removeClass('loading');
        }, 2000);
    })

    $('.misc_cookiesinfo .content_sat .cookieShowLightbox').click(function() {
        $('.misc_cookiesinfo #cookiesLightbox').addClass('displayCookies');
        if($('.misc_cookiesinfo #cookiesLightbox').has('.hideCookies')) {
            $('.misc_cookiesinfo #cookiesLightbox').removeClass('hideCookies');
        }
        $('.misc_cookiesinfo #cookiesLightbox .w-form-line.w-submit button.w-loader').addClass('hideLoader');
    });

    $('.misc_cookiesinfo #js_cookie_refuse, .misc_cookiesinfo #js_cookie_accept').click(function() {
        if($('.misc_cookiesinfo #cookiesLightbox').has('.displayCookies')) {
            setTimeout(() => {
                $('.misc_cookiesinfo #cookiesLightbox').removeClass('displayCookies');
                $('.misc_cookiesinfo #cookiesLightbox').addClass('hideCookies');
            }, 300);
        }
    });

//To style the footer after submitting the client review form
    if ($('body.avis_clients').length && $('.titre_contact_submitted').length) {
        // Check if the screen size is between 1440 and 1920 pixels
        var screenWidth = $(window).width();
        if (screenWidth >= 1440 && screenWidth <= 1920) {
            $('body.avis_clients #copyright.footer').css({
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
            });
        }
    }

    // Ipad - clone .wrap_lang to the left menu
    if ($('#top_wrapper .wrap_lang').length) {
        const clonedWrapLang = $('#top_wrapper .wrap_lang').clone();
        clonedWrapLang.appendTo('#top_wrapper .left .main_menu_wrapper');
    }

    // Ipad - clone .storeloc to the left menu
    if ($('#top_wrapper .storeloc').length) {
        const clonedStoreLoc = $('#top_wrapper .storeloc').clone();
        clonedStoreLoc.appendTo('#top_wrapper .left .main_menu_contents');
        clonedStoreLoc.children().first().addClass('menu_supercateg').text(Translator.translate("ariane_distributeurs"));
    }

    // MENU BURGER SHAD - open/close on click
    if ($('#top_wrapper .burger_menu_container').length) {
        $('#top_wrapper').on('click tap touch', '.burger_menu_container', function() {
            if(!$('.burger_menu_container .burger_menu').hasClass('is-clicked')) {
                $('#shad').addClass('actif').addClass('burger_menu_open');
                $('body').addClass('noscroll');

            } else {
                $('#shad').removeClass('actif').removeClass('burger_menu_open');
                $('body').removeClass('noscroll');
            }
        });
    }

    // ON CLICK ON SHAD, CLOSE MENU BURGER
    $("#shad").on("click tap touch", function () {
        burgerMenuClosed();
    });

    clickableBoxCookies();

    if ($('body').hasClass('product_page')) {
        attachLoadingHandler('.btn-select-store .w-submit-button');
        attachLoadingHandler('.click_and_go_enable .disponibility_retire');
    }


    // Fiche magasin store locator associated products
    if ($('#associated_products_container').length) {
        new Swiper('#associated_products_container', {
            slidesPerView: 3.1,
            spaceBetween: 15,
            pagination: {
                el: '.associated_pagination',
                clickable: true,
            }
        });
    }

    //order by type filter
    $(".order_filter").on('click', function() {
        var target = $(this).data('orderfilter');
        $('#type_actif').val(target);
    });

    // WP-32515 - "Voir plus" commandes : chargement AJAX de la page suivante (pas de reload complet)
    // Délégation car le bouton est ré-injecté à chaque chargement.
    $(document).on('click', '.btn_voir_plus', function(e) {
        e.preventDefault();

        var $btn = $(this);
        var href = $btn.attr('data-url');
        var $loader = $btn.siblings('.loader');

        if (!href || $loader.hasClass('loading')) {
            return;
        }

        // On conserve l'onglet de filtre actif : le filtrage est piloté par l'attribut
        // "value" de #type_actif via le CSS :has(), or le partiel rechargé le remet à "all".
        var activeFilter = $('#type_actif').val() || $('#type_actif').attr('value') || 'order_filter_all';

        $loader.addClass('loading');

        $.ajax({
            url: href,
            type: 'GET',
            dataType: 'html'
        }).done(function(response) {
            var parsed = new DOMParser().parseFromString(response, 'text/html');
            var newList = parsed.querySelector('#orders_by_type');

            // Si on n'a pas pu extraire la liste, on retombe sur la navigation classique.
            if (!newList) {
                window.location = href;
                return;
            }

            $('#orders_by_type').replaceWith(newList.outerHTML);
            $('#type_actif').attr('value', activeFilter).val(activeFilter);

            var newMore = parsed.querySelector('.orders_load_more');
            if (newMore) {
                $('.orders_load_more').replaceWith(newMore.outerHTML);
            } else {
                $('.orders_load_more').remove();
            }
        }).fail(function() {
            $loader.removeClass('loading');
            window.location = href;
        });
    });

    // internal-link-wrapper see more/see less functionality START //
    let internalLink = $('.internal-links');
    let voirPlusBtn = '#voir_plus_btn';

    if ($('.internal-links a').length > 8) {
        $('<div id="voir_plus_btn">' + Translator.translate('see_more') + '</div>').insertAfter('.internal-links');
    }

    $(voirPlusBtn).on('click', function() {
        if(!internalLink.hasClass('show-links')) {
            internalLink.addClass('show-links');
            $(voirPlusBtn).text(Translator.translate('see_less'));
        } else {
            internalLink.removeClass('show-links');
            $(voirPlusBtn).text(Translator.translate('see_more'));

            var $el = internalLink;
            if ($el.length) {
                $('html, body').animate({
                    scrollTop: $el.offset().top - (($(window).height()/2) + ($el.outerHeight()/2) - 300)
                }, 500);
            }
        }
    });
    // internal-link-wrapper see more/see less functionality END //

    // Manage FP back button on mobile product page
    $(document).on('click', '.product_info_wrapper .itm_back_btn', handleDesktopProductBack);

    // Manage CMS back button click event to handle internal history and fallback URLs
    $(document).on('click', '#cms_page_btn_back .itm_back_btn', handleCmsBack);
});

function handleDesktopProductBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var breadcrumbLinks = document.querySelectorAll('#breadcrumbs .breadcrumb a');
    var objectLevelLink = breadcrumbLinks[breadcrumbLinks.length - 1];

    if (objectLevelLink) {
        window.location.assign(objectLevelLink.href);
        return;
    }

    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(homeUrl);
}

function handleCmsBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var cmsUrlBack = event.currentTarget.getAttribute('data-cms-url-back');
    var parentUrl = event.currentTarget.getAttribute('data-cms-parent-url');
    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(cmsUrlBack || parentUrl || homeUrl);
}

$(".sizesList label").on("click", function () {
    $(".choices_list").removeClass("opened");
});

function attachLoadingHandler(selector) {

    $(document).on('click', selector, function() {

      const $button = $(this);
      $button.addClass('loading');

      setTimeout(() => {
        $button.removeClass('loading');
      }, 2000);
    });
  }



function clickableBoxCookies() {
    // Define the URL for redirection
    const linkUrl = "https://business.safety.google/privacy/";

    // Get the positions of the labels and create clickable overlays
    $('#cookiePref02 label.w-input.w-checkbox-input').each(function() {
        const $label = $(this);
        const offset = $label.offset();

        // Create an invisible clickable block for #cookiePref02
        const clickableBlock = $('<div></div>').css({
            position: 'absolute',
            width: '14px',
            height: '14px',
            top: '.15rem',
            right: '-1.15rem',
            cursor: 'pointer',
            zIndex: 10,
            backgroundColor: 'transparent'
        }).click(function() {
            window.open(linkUrl, '_blank');
        });

        // Append the clickable block inside #cookiePref02
        $('#cookiePref02 .multiline').append(clickableBlock);
    });

    $('#cookiePref03 label.w-input.w-checkbox-input').each(function() {
        const $label = $(this);
        const offset = $label.offset();

        // Create an invisible clickable block for #cookiePref03
        const clickableBlock = $('<div></div>').css({
            position: 'absolute',
            width: '14px',
            height: '14px',
            top: '.15rem',
            right: '-1.15rem',
            cursor: 'pointer',
            zIndex: 10,
            backgroundColor: 'transparent'
        }).click(function() {
            window.open(linkUrl, '_blank');
        });

        // Append the clickable block inside #cookiePref03
        $('#cookiePref03 .multiline').append(clickableBlock);
    });
};

function initProductSizeFieldset(parent) {
    /**
     Function to simulate the behavior of a select
     */
    $(parent + " .productSizeFieldset").on("click touch", function () {
        var sizesList = $(".sizesList", $(this));
        var shadSelect = $(".shadSelect");

        sizesList.toggleClass("opened");
        $(this).toggleClass("actif");

        if (!sizesList.hasClass("opened")) {
            $(this).removeClass("actif");
        }

        shadSelect.on("click touch", function () {
            sizesList.removeClass("opened");
            $(this).removeClass("actif");
            $(parent + " .productSizeFieldset").removeClass("actif");
        });
    });

}

function goBack(toUrl) {
    if (toUrl) {
        window.location.href = path_relative_root;
    } else {
        var url = window.location.href;
        if (url.indexOf("#search") > -1) {
            var new_url = url.substring(0, url.indexOf("#search"));
            window.location.href = new_url;
        } else {
            window.history.back();
        }
    }
}

/** Close Popup know more connexion page */
function close_popup(elem) {
    var $modbox = $("#" + elem);
    var $shad = $("#shad");
    $shad.attr("onclick", "");
    $shad.animate({ opacity: 0 }, 350, function () {
        $shad.css({ display: "none", opacity: "" }).data("opened_lb", 0);
    });
    $modbox.css({ display: "none" });
}

$(".menu_itm_hover")
    .on("mouseenter touchStart", function () {
        $("#shad_menu").addClass("actif");
    })
    .on("mouseleave", function () {
        $("#shad_menu").removeClass("actif");
    });

// Pour afficher le panier sur le coté (utilisé aussi dans product.js à l'ajout du panier)
function topCartAppear() {
    var show_top_cart_parent = $("#show_top_cart");
    var count_bask = $("#cart_top .cart").attr("data-cart");

    if ($("#show_top_cart .gondoleInterest .swiper-slide").length > 1) {
        new Swiper("#show_top_cart .gondoleInterest", {
            direction: "vertical",
            slidesPerView: "auto",
            slidesPerGroup: 1,
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            mousewheel: true,
        });
    }

    /* Closing look lightbox if displayed */
    if ($(".lookLightbox.actif").length) {
        $(".lookLightbox").removeClass("actif");
    }

    if ($("body.cart").length) {
        $(".block_top_item.my_basket a").addClass("shop_b");
        show_top_cart_parent.addClass("hover");
        $("#shad_menu").addClass("actif");
    } else {
        show_top_cart_parent.addClass("hover");
        $("#shad_menu").addClass("actif");
        $(".cart ").removeClass("shop");
        $(".cart ").addClass("shop_b");
    }
}

// Pour afficher le panier sur le coté (utilisé aussi dans product.js à l'ajout du panier)
function topCartDesappear() {
    var show_top_cart_parent = $("#show_top_cart");
    if ($("body.cart").length) {
        $(".block_top_item.my_basket a").addClass("shop_b");
        show_top_cart_parent.removeClass("hover");
        $(".smallbasketExpress").removeClass("actif");
        $("#shad_menu").removeClass("actif");
    } else {
        show_top_cart_parent.removeClass("hover");
        $(".smallbasketExpress").removeClass("actif");
        $("#shad_menu").removeClass("actif");
        $(".cart ").removeClass("shop_b");
        $(".cart ").addClass("shop");
    }
}

$("#cart_top").on("mouseenter", function () {
    topCartAppear();
});

$("#cart_top").on("mouseleave", function () {
    topCartDesappear();
});

/**
 * Switch icons color on rollover + display sahd
 */
if ($("body.customer").length) {
    $(".block_top_item.my_account a").addClass("user_b");
}

$(".block_top_item.my_account")
    .on("mouseenter", function () {
        $(".my_account a").removeClass("user");
        $(".my_account a").addClass("user_b");

        if ($(".is_logged").length) {
            $("#shad_menu ").addClass("actif");
        }
    })
    .on("mouseleave", function () {
        $(".my_account a").removeClass("user_b");
        $(".my_account a").addClass("user");

        if ($(".is_logged").length) {
            $("#shad_menu ").removeClass("actif");
        }
    });

if ($("body.cart").length) {
    $(".block_top_item.my_basket a").addClass("shop_b");
}

if ($("body.wishlist").length) {
    $(".block_top_item.whislist a").addClass("heart_b");
} else {
    $(".block_top_item.whislist")
        .on("mouseenter", function () {
            $(".whislist a").removeClass("heart");
            $(".whislist a").addClass("heart_b");
        })
        .on("mouseleave", function () {
            $(".whislist a").removeClass("heart_b");
            $(".whislist a").addClass("heart");
        });
}

$("#addToWishlistButton").on("mouseenter", function () {
    $(this).removeClass("heart");
    $(this).addClass("heart_b");
});

if ($("body.store_locator").length) {
    $(".storeloc a").addClass("search_b");
} else {
    $(".storeloc a").on("mouseenter", function () {
        $(this).removeClass("search");
        $(this).addClass("search_b");
    });

    $(".storeloc a").on("mouseleave", function () {
        $(this).removeClass("search_b");
        $(this).addClass("search");
    });
}

$("#addToWishlistButton").on("mouseleave", function () {
    if (!$(this).hasClass("existToWishlistButton")) {
        $(this).removeClass("heart_b");
        $(this).addClass("heart");
    }
});

$("#btn_add_cart").on('click', function () {
    setTimeout(function () {
        $('.loader').removeClass('loading');
    }, 2500)
})

$("#zoomBox img").on("click", function () {
    closeMultiShad("zoomBox");
});

$(window).scroll(function () {
    if ($(".bandeauMenuAffix").length) {
        if ($(document).scrollTop() > 0) {
            $(".hasBando").removeClass("hasBando");
            $("body").addClass("bandoCollapsed");
        } else {
            $("body").addClass("hasBando");
            $(".bandoCollapsed").removeClass("bandoCollapsed");
        }
    }
});

$("#top_wrapper")
    .on("mouseenter", function () {
        $("#site_head_wrap").addClass("sticky");
    })
    .on("mouseleave", function () {
        if ($(document).scrollTop() === 0 && !$(".wrap_search_field").is(":visible")) {
            $("#site_head_wrap").removeClass("sticky");
        }
    });

$(".my_account").on("mouseenter", function () {
    $(this).children(".connexion_top").addClass("hover");
});
$(".my_account").on("mouseleave", function () {
    $(this).children(".connexion_top").removeClass("hover");
});

$(".showAmountBtn").on("click", function () {
    $(".pageGiftCard__main--amountinfos").addClass("actif");
    $("#shad").addClass("actif");
});

$(".pageGiftCard__main--amountinfos .close").on("click", function () {
    $(".pageGiftCard__main--amountinfos").removeClass("actif");
    $("#shad").removeClass("actif");
});

$(".pageGiftCard__main--amountinfos .return").on("click", function () {
    $(".pageGiftCard__main--amountinfos").removeClass("actif");
    $("#shad").removeClass("actif");
});

/**
 * Bank thanks create account button loader
 */
$(document).on("click touch", ".bankThanksBtn", function () {
    $(this).addClass("loading");
});

/* ------------------------------ HOME ------------------------------ */

$(function () {
    // Preheader
    window.setTimeout(function () {
        if ($(".bandeau_header .swiper-slide").length > 1) {
            preheaderSwiper = new Swiper(".bandeau_header .swiper-container", {
                slidesPerView: 1,
                speed: 1500,
                autoplay: {
                    delay: 4500,
                    disableOnInteraction: false,
                },
                loop: true,
            });
        }

        if ($(".bandeau_header").length) {
            $("body").addClass("hasBando");
        }
    }, 1000);

    /** COVER MODULE */
    if ($(".sliderMainHome").length) {
        var homeSwiper = new Swiper(".sliderMainHome", {
            roundLengths: true,
            slidesPerView: 1,
            pagination: {
                el: ".cover-module-pagination",
                clickable: true,
            },
            loop: true,
            autoplay: {
                delay: 5000,
            },
        });
        // Stop autoplay on mouse hover
        $(".sliderMainHome").on("mouseenter", function (e) {
            homeSwiper.autoplay.stop();
        });
        $(".sliderMainHome").on("mouseleave", function (e) {
            homeSwiper.autoplay.start();
        });
    }

    /** TG MODULE */
    if ($(".tg-module .slider").length) {
        // iterate through all swipers with the same id
        $(".tg-module .slider").each(function (index) {
            var $this = $(this);
            $this.addClass("s-" + index);
            $this
                .parent()
                .find(".tg-module-pagination")
                .addClass("pagination-" + index);
            $this
                .parent()
                .find(".tg-module-pagination")
                .addClass("tg-module-pagination" + index);
            var tgSwiper = new Swiper(".s-" + index, {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 15,
                observeParents: true,
                observer: true,
                uniqueNavElements: false,
                pagination: {
                    el: ".tg-module-pagination" + index,
                    clickable: true,
                    type: "bullets",
                },
                breakpoints: {
                    1025: {
                        slidesPerView: 4,
                    },
                },
            });
        });
    }

    /** SOCIAL MODULE */
    if ($("#sliderHomeInsta").length) {
        new Swiper("#sliderHomeInsta", {
            slidesPerView: 4.5,
            observeParents: true,
            observer: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

/** STORE DETAIL IMAGE SWIPER **/
if ($("#nearby_lists").length) {
    new Swiper("#nearby_lists", {
        slidesPerView: 4,
    });
}

    initFPCharacts();

    // Store detail image resizing on small screens
    var storeImageWrapper = $(".satellite_store_details .store_img");
    var storeDetailImg = $(".left-side-img");

    if (storeDetailImg) {
        var storeDetailImgUrl = storeDetailImg.attr("src");
        storeImageWrapper.css("--image-url", "url(" + storeDetailImgUrl + ")");
    }

    /* ------------------------------ CONTACT FAQ ------------------------------ */
    var contactFaqWrapper = $(".contact_faq #block_img");
    var contactFaqImg = $(".contact_faq_img");

    if (contactFaqImg) {
        var contactFaqImgImgUrl = contactFaqImg.attr("src");
        contactFaqWrapper.css(
            "--contact-faq-image-url",
            "url(" + contactFaqImgImgUrl + ")"
        );
    }

    /* ------------------------------MODULE LOOKBOOK PIN ------------------------------ */
    var tags = $(".cms_page_content .tag");
    tags.each(function () {
        var tag = $(this);
        var tagPrice = tag.find(".imgWrapper .item_price");
        var tagItemDescription = tag.find(".block_lnk .wrapper_description");
        tagPrice.insertAfter(tagItemDescription);
    });

    if ($(".product_page").length) {
        initTaille();
        rayon_sticky_block();
        swiperAssociation();
        swiperArticlesVue();
        initProductSizeFieldset(".product_main_wrapper");
    }

    var strongElement = $(
        "body.newsletter .content_newsletter .optin-select-line .multiline strong"
    );
    strongElement.replaceWith(function () {
        return $("<div/>", {
            class: "no_strong",
            html: this.innerHTML,
        });
    });

    // Store list scrollbar
    $(".sub_cat_name").click(function () {
        $(".sub_cat_name").removeClass("active");
        $(this).addClass("active");
    });

    if ($("body.store_locator").length) {
        setTimeout(function () {
            $(".section-list-store").overlayScrollbars({});
        }, 250);
    }

    if ($("body.in_tunnel").length) {
        setTimeout(function () {
            $(".list-right").overlayScrollbars({});
        }, 650);
    }

    // Swiper verified advices
    if ($(".descrip_avis_ctn").length) {
        new Swiper("#bloc_reviews_slider", {
            slidesPerView: 2.5,
            spaceBetween: 15,
            observeParents: true,
            roundLengths: true,
            observer: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    // Swiper association products
    if ($(".product_associations_wrapper.gondole").length) {
        // iterate through all swipers with the same id
        $("#productAssociationSwiper").each(function (index) {
            var $this = $(this);
            $this.addClass("s-" + index);
            $this
                .parent()
                .find(".product-associations-pagination")
                .addClass("pagination-" + index);
            $this
                .parent()
                .find(".product-associations-pagination")
                .addClass("product-associations-pagination" + index);
            var tgSwiper = new Swiper(".s-" + index, {
                observeParents: true,
                observer: true,
                uniqueNavElements: false,
                pagination: {
                    el: ".product-associations-pagination" + index,
                    clickable: true,
                    type: "bullets",
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                    },
                },
            });
        });
    }

    /**
     * Add 'withUpselling' class on tunnel summary when upselling is active
     * needed for positioning cart push
     */
    if ($(".cart.step_1").length && $(".upselling_alma").length) {
        $("#tunnel_right_col").addClass("withUpselling");
    }

    /* ------------------------------ RECRUTEMENT ------------------------------ */

    var formContactModule = $(".form_contact_module");
    if (formContactModule.length) {
        $(".form_contact_module")
            .parent()
            .parent()
            .addClass("cms_page_recruitment");
    }

    var recruitmentPage = $(".main_wrapper .cms_page_recruitment");
    var recruitmentPageAriane = $(".cms_page_recruitment #cms_page_ariane");
    var btnBack = $(".cms_page_recruitment #cms_page_btn_back");
    if (recruitmentPage.length) {
        recruitmentPageAriane.show();
        btnBack.hide();
    }

    // if a tag is set on module call the function
    if ($(".cms-page-module").find(".tag").length) {
        tagPositionForHomeModule();
    }
    $(".tag")
        .on("mouseenter touchStart", function () {
            $(this).parent().find(".cms-page-column img").addClass("filter_on");
        })
        .on("mouseleave", function () {
            $(this)
                .parent()
                .find(".cms-page-column img")
                .removeClass("filter_on");
        });

    var currentItem = $(this).closest(".main_menu_itm.menu_itm_hover");
    if ($("#maison").hasClass("current")) {
        currentItem.addClass("selected_menu");
    } else {
        currentItem.removeClass("selected_menu");
    }

    /* swiper on satellite univers pages*/
    if ($("#timeline .swiper-slide").length > 0) {
        timelineSwiper = new Swiper("#timeline", {
            slidesPerView: 4.725,
        });
    }

    if ($("#timeline-logo .swiper-slide").length > 0) {
        timelineSwiper = new Swiper("#timeline-logo", {
            slidesPerView: 5,
        });
    }

    if ($("#our_selection .swiper-slide").length > 0) {
        ourSelection = new Swiper("#our_selection", {
            slidesPerView: 4,
            spaceBetween: 15,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    if ($("#banner-swiper .swiper-slide").length > 0) {
        selection = new Swiper("#banner-swiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    /* remove the white background on satellite univers pages */
    if ($("body .satellite-page").length > 0) {
        $("body").addClass("universe-pages");

        $(window).on("load scroll", function () {
            const $topWrapper = $("#site_head_wrap");
            const scrollPosition = $(window).scrollTop();

            if (scrollPosition <= 20) {
                $topWrapper.addClass("scroll_bg_transparent");
            } else {
                $topWrapper.removeClass("scroll_bg_transparent");
            }
        });
    }

    $(".switch-btn").each(function () {
        $(this).on("click touch tap", function () {

            // Check if switch-btn instances have the active class
            if (!$(this).hasClass("active")) {
                // Remove all active classes from all switch buttons
                $(".switch-btn").removeClass("active");

                // Add the active class only to the clicked button
                $(this).addClass("active");

                var getBlocName = $(this).attr("data-filter");

                var $correspondingSlider = $(".switch-slider[data-filter='" + getBlocName + "']");

                if ($correspondingSlider.length > 0) {
                    $(".switch-slider").removeClass("active");

                    $correspondingSlider.addClass("active");

                    var newUrl = window.location.href.split('#')[0];

                    if (getBlocName) {
                        newUrl += "#" + getBlocName;
                    }

                    window.history.pushState({}, '', newUrl);
                }
            }
        });
    });

    /* interaction on the shoe svg */
    function handleInteraction(animation) {
        var getTiggerPartName = animation.attr("data-name");
        $(".interactive-btn, .non-active-state").removeClass('active');
        animation.addClass('active');

        $(".shoe-sec").each(function () {
            var getShoePart = $(this).attr("data-name");
            if (getTiggerPartName == getShoePart) {
                $(".shoe-sec").removeClass("show");
                $(this).addClass("show");
            }
        });

        $(".non-active-state").each(function () {
            var getShadePart = $(this).attr("data-name");
            if (getTiggerPartName == getShadePart) {
                $(".non-active-state").removeClass("active");
                $('[data-name=' + getShadePart + ']').addClass('active');
            }
        });
    }

    function removeHandleInteraction() {
        $(".interactive-btn, .non-active-state").removeClass('active');
        $(".shoe-sec").removeClass("show");
    }

    $(".interactive-btn").each(function () {
        $(this).hover(function () {
            handleInteraction($(this));
        }, function () {
            removeHandleInteraction()
        });
    });

    $(".non-active-state").each(function () {
        $(this).hover(function () {
            handleInteraction($(this));
        }, function () {
            removeHandleInteraction()
        });
    });
    /* end interaction */

    if ($('html').is(':lang(en)')) {
        if ($('body.satellite_conseils_entretien')) {
            $('.shoe-sec').addClass('text-en');
        }
    }

    /* Recherche bar on press enter button close search bar */
    $("#search_home").on("keypress", function (event) {
        if (event.which === 13) {
            closeSearch();
        }
    });

    // on cleared Search Input

    $("#search_home").on("keypress", function (event) {
        if (event.which === 13) {
            closeSearch();
        }
    });

    // Initialize item sliders
    initializeItemSliders();

    // Hide the gift card if the customer is identified on the Global-e site
    window.addEventListener('loadGlobalE_complete', function() {
        if (isGlobalEActive) {
            $(".disable_globale").each(function () {
                if (!$(this).hasClass("disabled")) {
                    $(this).addClass("disabled");
                }
            });

            var menu_carte_cadeau = $(".main_menu_wrapper .link_giftCard");
            var footer_carte_cadeau = $(
                "footer .satellites li.menu_giftcard"
            );
            menu_carte_cadeau.hide();
            footer_carte_cadeau.hide();
        }
    });

    // Verify that the page contains the desired class
    if (document.body.classList.contains("universe-pages")) {
        showElementOfUrlId();
    }

    // Run on window load
    checkWidthForMenuIpad();

    // Run on window resize
    $(window).resize(function() {
        checkWidthForMenuIpad();
    });

    burgerMenu();

    // Ipad - Dropdown Menu
    $('.main_menu_wrapper .menu_supercateg').each(function() {
        $(this).on('click tap touch', function() {
            if($('#top_wrapper').hasClass('ipadMenu')) {
                if(!$(this).hasClass('open')) {
                    $('.main_menu_wrapper .menu_supercateg').removeClass('open').next().removeClass('open').slideUp(250);
                    $(this).addClass('open').next().addClass('open').slideDown(250);

                } else if($(this).hasClass('open')){
                    $(this).removeClass('open').next().removeClass('open').slideUp(250);
                }
            }
        });
    });

    $('.cms_page_new .images3 .tag').on('click', function () {
        // Small delay to let the lightbox open first
        setTimeout(() => {
            const intervalCheck = setInterval(() => {
                // If the lightbox is no longer active, remove 'actif' from #shad and stop checking
                if (!$('.lightbox.smallbasketExpress').hasClass('actif')) {
                    $('#shad').removeClass('actif');
                    clearInterval(intervalCheck);
                }
            }, 300);
        }, 600);
    });

    // Country select init with select2
    $('#countries_select').select2({
        width: 'resolve',
        placeholder: Translator.translate('choose_country'),
        templateResult: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option    = $(data.element);
            const countryId  = $option.data('country-id');
            const $node = $('<span></span>');

            $node.text(data.text);
            $node.attr('data-country-id', countryId);

            return $node;
        },
        templateSelection: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option    = $(data.element);
            const countryId  = $option.data('country-id');
            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-country-id', countryId);

            return $node;
        },
    });

    $('#countries_select').on('select2:open', function () {
        const $search = $('.select2-container .select2-search__field');

        $search.attr('placeholder', Translator.translate('search_country_placeholder'));

        setTimeout(function () {
            $search.trigger('focus');
        }, 100);
    });

    $('#country_langs_select').select2({
        minimumResultsForSearch: -1,
        width: 'resolve',
        templateResult: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option = $(data.element);
            const isDefault = $option.data('default');

            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-default', isDefault);

            return $node;
        },
        templateSelection: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option = $(data.element);
            const isDefault = $option.data('default');

            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-default', isDefault);

            return $node;
        },
    });

    // SW-19561 - handle #search=??? in home module
    document.querySelectorAll('.home-module-body a[href*="#search="]').forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Gets the href attribute
            const href = link.getAttribute("href");

            // Extracts the search value from the hash
            const match = href.match(/#search=([^&]+)/);

            if (match && match[1]) {
                const searchValue = match[1]; // ex : "sergent%20major"

                // Starts a search with the extracted value
                if (!window.wShop) {
                    console.error("wShop is not defined.");
                    return;
                }

                window.wShop.searchStr = searchValue;
                // Add also the search value in the search input if exists
                try {
                    $("#search_home").val(decodeURIComponent(searchValue));
                    applySearchClass();
                } catch (e) {
                    console.error("Error setting search input value:", e);
                }
                window.wShop.getProducts();
                document.addEventListener("search_getProducts_end", function () {
                    applySearchClass();
                }, { once: true });
            }
        });
    });
});

function applySearchClass() {
    let searchInputValue = $("#search_home").val();

    if (searchInputValue.length >= 3) {
        $('body').addClass('search_in');
    } else {
        $('body').removeClass('search_in');
    }
}

// check Width For MenuIpad
function checkWidthForMenuIpad() {
    if ($(window).width() < 1018) {
        $('#top_wrapper').addClass('ipadMenu');
        $('.main_menu_wrapper .submenu_wrapper').hide();

        // Add overlayScrollbars to each element
        $(".supercateg_item .submenu_wrapper").each(function() {
            if (!$(this).hasClass('os-host')) { // Check if overlayScrollbars is not already applied
                $(this).overlayScrollbars({});
            }
        });

    } else {
        $('#top_wrapper').removeClass('ipadMenu');
        $('.main_menu_wrapper .submenu_wrapper').removeAttr('style');

        // Remove overlayScrollbars from each element
        $(".supercateg_item .submenu_wrapper").each(function() {
            if ($(this).hasClass('os-host')) { // Check if overlayScrollbars is applied
                $(this).overlayScrollbars().destroy();
            }
        });

        // IF MENU BURGER WAS OPEN WHEN RESIZING TO >= 1025, REMOVE SHAD
        burgerMenuClosed();
    }

    searchWidthCheck();
}

function searchWidthCheck() {
    const triggerRecherche = $("#trigger_recherche");
    const triggerWidth = triggerRecherche.width();

    if (triggerWidth < 100) {
        triggerRecherche.removeClass('showSearchPlaceholder');
    } else {
        triggerRecherche.addClass('showSearchPlaceholder');
    }
}

/***** IPAD - BURGER MENU *****/
function burgerMenu() {
    $('#top_wrapper').on('click tap touch', '.burger_menu_container', function() {
        if($('#top_wrapper').hasClass('ipadMenu')) {
            $('#site_head_wrap').toggleClass('no_scroll');
            $('.burger_menu').toggleClass('is-clicked');
            $('.main_menu_wrapper').toggleClass('is-open');
        }
    });
}

/***** IPAD - BURGER MENU - close and remove classes associated *****/
function burgerMenuClosed() {
    if ($("#shad").hasClass("burger_menu_open")) {
        $("#shad").removeClass("burger_menu_open actif");
        $('#site_head_wrap').removeClass('no_scroll');
        $('.burger_menu').removeClass('is-clicked');
        $('.main_menu_wrapper').removeClass('is-open');
        $('body').removeClass('noscroll');
    }
}

window.onload = function() {
    // Remove the pre-filled input value of inscription nl when the page loads
    if ($('.footerInscription .w-email-input .w-input-element').length) {
        setTimeout(function() {
            $('.footerInscription .w-input.w-email-input input[type="email"]').val('');
        }, 250);
    };
};

function initFPCharacts() {
    if ($(".fp_characts").length) {
        $(".fp_characts").on("mouseenter", function () {
            $(".fp_characts").removeClass("active");
            $(".fp_characts_description").hide();
            var id = $(this).attr("caract_id");
            $(this).addClass("active");
            $(".characts_description_" + id).slideDown("slow");
        });
        $(".fp_characts").on("mouseleave", function () {
            $(".fp_characts").removeClass("active");
            $(".fp_characts_description").hide();
        });
    }
}

/* ------------------------------ PAGE PRODUIT ------------------------------ */
function initTaille() {
    // changement select pointure lorsqu'on clique sur une taille
    $(".product_info_wrapper .choices_list .form_itm.size label").on(
        "click",
        function () {
            var taille = $(this).children().children().html();
            var isAvailable = $(this).hasClass("noStock") ? false : true;
            var shadSelect = $(".shadSelect");

            window.setTimeout(function () {
                shadSelect.removeClass("actif");
            }, 100);

            if (isAvailable === false) {
                $(".prod_listes .size_title").html(
                    '<span class="size_title_content noStock">' +
                    taille +
                    "</span>"
                );
            } else {
                $(".prod_listes .size_title").html(
                    '<span class="size_title_content">' + taille + "</span>"
                );
            }

            if (
                $("#bloc_add_basket #btn_add_cart").data("type") ===
                "add_basket_preco"
            ) {
                $("#bloc_add_basket #fpWrapperBtn").html(
                    Translator.translate("add_basket_preco")
                );
            } else {
                $(".product_info:not(.scrolling-active) #bloc_add_basket #fpWrapperBtn").html(
                    Translator.translate("add_basket")
                );
            }

            $("#bloc_add_basket #fpWrapperBtn").removeClass("noSize");
        }
    );

    $(".product_info_wrapper .choices_list .form_itm .disabled").on(
        "click",
        function () {
            window.setTimeout(function () {
                $("#bloc_add_alert").show();
            }, 200);

            lightboxAlertStock();
        }
    );

    window.setTimeout(function () {
        if ($("#bloc_add_basket").hasClass("inactiv")) {
            $("#bloc_add_basket #btn_add_cart").val(
                Translator.translate("choose_a_size")
            );
        }
        initPriceBtn();
    }, 1000);
}

function rayon_sticky_block() {
    setTimeout(function () {
        // Add class to body when scrolling
        var targetDiv = $(".product_info");
        var targetTop = $(".product_info_wrapper");
        var targetDivHeight = targetDiv.height();

        $(window).scroll(function () {
            var windowpos = $(window).scrollTop();
            if (windowpos >= targetDivHeight) {
                $("#ligne_pointure .choices_list").removeClass("sizesList");
                targetDiv.addClass("scrolling-active");
                targetTop.addClass("padd-bot");
                targetTop.css('padding-top', targetDivHeight + 'px');
                setTimeout(function () {
                    targetDiv.addClass("appa");
                }, 100);

            } else {
                $("#ligne_pointure .choices_list").addClass("sizesList");
                targetDiv.removeClass("scrolling-active");
                targetTop.removeClass("padd-bot");
                targetDiv.removeClass("appa");
                targetTop.css('padding-top', 'initial');
            }
        });
    }, 500);
}

function initPriceBtn() {
    var bloc_add_basket = $("#bloc_add_basket");
    var fpWrapperBtn = $("#fpWrapperBtn");
    var price = $(".page_produit .item_price .price_tag:first-child").html();
    var initialLabel = $("#fpWrapperBtn").data("label");
    var tailleProd = $("#tailleProd");
    var newLabel =
        '<span class="text-price">' +
        initialLabel +
        "</span>" +
        "|" +
        '<span class="price-butt">' +
        price +
        "</span>";

    if (bloc_add_basket.hasClass("inactiv")) {
        fpWrapperBtn.html(Translator.translate("choose_a_size"));
        fpWrapperBtn.addClass("noSize");

    } else if (tailleProd && tailleProd.length && tailleProd.val() !== "") {
        fpWrapperBtn.html($(".product_info").hasClass("scrolling-active") ? newLabel : initialLabel);
        fpWrapperBtn.removeClass("noSize");
    }

    var productInfo = $(".product_info");
    var lastState = null;

    function syncBtnLabel() {
        var isSticky = productInfo.hasClass("scrolling-active");
        var state = isSticky + "|" + bloc_add_basket.hasClass("inactiv") + "|" + $("#bloc_add_basket #btn_add_cart").hasClass("unlock") + "|" + (tailleProd.length ? tailleProd.val() : "");
        if (state === lastState) {
            return;
        }
        lastState = state;
        {
            if (isSticky) {
                if ((bloc_add_basket.hasClass("inactiv") || !$("#bloc_add_basket #btn_add_cart").hasClass("unlock")) && tailleProd && tailleProd.length && tailleProd.val() == "") {
                    fpWrapperBtn.html(Translator.translate("choose_a_size"));
                    fpWrapperBtn.addClass("noSize");
                } else if ($("#bloc_add_basket #btn_add_cart").hasClass("unlock")) {
                    fpWrapperBtn.html(newLabel);
                    fpWrapperBtn.removeClass("noSize");
                }
            } else {
                if (bloc_add_basket.hasClass("inactiv")) {
                    fpWrapperBtn.html(Translator.translate("choose_a_size"));
                    fpWrapperBtn.addClass("noSize");
                } else if (tailleProd && tailleProd.length && tailleProd.val() !== "") {
                    fpWrapperBtn.html(initialLabel);
                    fpWrapperBtn.removeClass("noSize");
                } else {
                    bloc_add_basket.addClass("inactiv");
                    fpWrapperBtn.html(Translator.translate("choose_a_size"));
                    fpWrapperBtn.addClass("noSize");
                }
            }
        }
    }

    // Synchronous (no delay) to follow immediately the fixed / non fixed transition
    $(window).on("scroll", syncBtnLabel);
    $("#tailleProd, .product_info_wrapper .choices_list .form_itm.size label").on("change click", function () {
        setTimeout(syncBtnLabel, 0);
    });
}

function swiperAssociation() {
    new Swiper(".swiper-associations", {
        slidesPerView: 3,
        spaceBetween: 15,
        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
        },
        allowTouchMove: true,
        pagination: {
            el: ".swiper-associations-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".associationsNext",
            prevEl: ".associationsPrev",
        },
        watchOverflow: true,
        on: {
            // Les .productSwiper internes à chaque slide ne sont observés par
            // l'IntersectionObserver de initializeItemSliders() qu'une fois réellement visibles ;
            // avec 4 slides affichés d'un coup ici, on force le (re)scan pour ne pas en manquer.
            init: function () {
                initializeItemSliders();
            },
            slideChange: function () {
                initializeItemSliders();
            },
        },
    });

    setTimeout(function () {
        $(".swiper-associations").addClass("actif");
    }, 0);
}

function swiperArticlesVue() {
    setTimeout(function () {
        new Swiper(".swiper-articles-vues", {
            slidesPerView: 4,
            spaceBetween: 15,
            pagination: {
                el: ".swiper-articles-vues-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".last_seenNext",
                prevEl: ".last_seenPrev",
            },
            watchOverflow: true,
        });
        $(".swiper-articles-vues").addClass("actif");
    }, 500);
}

/* ------------------------------ ACCOUNT LOGIN ------------------------------ */

function afficheLostPasswordTop() {
    if ($("#bloc_erreur").is(":visible")) {
        $("#bloc_erreur").css("display", "none");
    }

    $("#is_client_form").hide();
    $("#lost_password_top").css({ display: "block", opacity: 0 }).fadeIn(600);
}

function reloadBlocLoginTop() {
    if ($("#bloc_erreur").is(":visible")) {
        $("#bloc_erreur").css("display", "none");
    }
    $("#lost_password_top").hide();
    $("#returning_customer_top").fadeIn(600);
}

// Verify phone number
function verif_telephone(elementID, fieldname, is_mobile) {
    var objElementHidden = document.getElementById(elementID + "Hidden");
    var objElement = document.getElementById(elementID);
    var erreurText = document.getElementById("erreur_msg");

    if (objElementHidden !== null) {
        var value = $(objElement).intlTelInput("getNumber");
        var type = $(objElement).intlTelInput("getNumberType");

        if (value.length == 12 && value.substr(1, 3) == "337") {
            if (elementID === "clientTel") {
                $("#clientMobileHidden").val(value);
            } else if (elementID == "telephone") {
                $("#mobileHidden").val(value);
            } else if (elementID == "billtelephone") {
                $("#billmobileHidden").val(value);
            } else if (elementID == "candidatTel") {
                $("#candidatTelHidden").val(value);
            }
        } else {
            if (
                $(objElement).intlTelInput("isValidNumber") !== false &&
                (type === 0 || type === 2 || type === 3 || type === 6)
            ) {
                $(objElementHidden).val(value);
            } else if (
                $(objElement).intlTelInput("isValidNumber") !== false &&
                type === 1
            ) {
                if (elementID === "clientTel") {
                    $("#clientMobileHidden").val(value);
                } else if (elementID == "telephone") {
                    $("#mobileHidden").val(value);
                } else if (elementID == "billtelephone") {
                    $("#billmobileHidden").val(value);
                } else if (elementID == "candidatTel") {
                    $("#candidatTelHidden").val(value);
                }
            }
        }

        if ($(objElement).intlTelInput("isValidNumber") === false) {
            $(objElement).addClass("inputErr");

            return false;
        }

        $(objElement).removeClass("inputErr");

        return true;
    }

    if ($.trim($(objElement).val()).length > 0) {
        if (
            $(objElement).intlTelInput("isValidNumber") === false ||
            (is_mobile && $(objElement).intlTelInput("getNumberType") === 0) ||
            (is_mobile == false &&
                $(objElement).intlTelInput("getNumberType") === 1)
        ) {
            if (
                is_mobile &&
                $(objElement).intlTelInput("getNumberType") === 0
            ) {
                erreurText.innerHTML =
                    '<p class="title_toolltip">' +
                    ajax_file(
                        "ajax_sprintf.php?arg2=" + fieldname + "_mobile"
                    ) +
                    " :</p>" +
                    ajax_file(
                        "ajax_sprintf.php?arg1=js_error_mobile&arg2=" +
                        fieldname
                    );
            } else {
                erreurText.innerHTML =
                    '<p class="title_toolltip">' +
                    ajax_file("ajax_sprintf.php?arg2=" + fieldname) +
                    " :</p>" +
                    ajax_file(
                        "ajax_sprintf.php?arg1=js_error_phone&arg2=" + fieldname
                    );
            }

            return false;
        } else {
            $(objElementHidden).val($(objElement).intlTelInput("getNumber"));
        }

        return true;
    }

    $(objElement).addClass("inputErr");

    return false;
}

function openMultiShad(id) {
    $("#" + id).addClass("actif");

    if (id === "lightbox_preco") {
        if (!$("#shad").hasClass("actif")) {
            $("#shad").addClass("actif");
        }
    } else if (id !== "zoomBox") {
        if (!$("#shad").hasClass("actif")) {
            $("#shad").addClass("actif");
        }

        $("#shad").on("click", function () {
            closeMultiShad(id);
        });
    }

    if (id === "zoomBox") {
        $("#zoom_box_wrapper .img_large").on("click", function () {
            closeMultiShad("zoomBox");
        });
    }

    if (id === "popup_savoir_plus") {
        $("#popup_savoir_plus").css("display", "block");
        $("#shad").css("display", "block");
    }

    if (id === "lightboxOrderGiftCard" || id === "sendwishlistbox") {
        $("#shad").addClass("actif");
    }

    if (id === "alertStockBox") {
        setTimeout(function () {
            new Swiper(".associated-product-lightbox", {
                slidesPerView: 2,
                grid: {
                    fill: "row",
                    rows: 2,
                },
                spaceBetween: 15,
                pagination: {
                    el: ".associated-product-lightbox-pagination",
                    clickable: true,
                },
            });
            $(".associated-product-lightbox").addClass("actif");
        }, 500);
    }

    if (id === "sizeguideBox") {
        $("body.product_page").addClass("no_hoverflow");
    }
}

function openSmallBasketExpress(id) {
    $("#show_top_cart").addClass("noDisplay");
    $(".smallbasketExpress").removeClass("actif");

    $(".productVisualMulti img[data-src]").each(function() {
        $(this).attr("src", $(this).attr("data-src"));
        $(this).removeAttr("data-src");
    });

    setTimeout(function () {
        if (!$('#shad_menu').hasClass('actif')) {
            $('#shad_menu').addClass('actif');

            $('#shad_menu').on('click', function () {
                closeSmallBasketExpress(id);
            });
        }

        $("#" + id).addClass("actif");
    }, 300);
}

function closeSmallBasketExpress(id) {
    if ($('#shad_menu').hasClass('actif')) {
        $('#shad_menu').removeClass('actif');
    }
    $("#" + id).removeClass("actif");
}

function closeMultiShad(id) {
    $("body").css("position", "");
    $("#" + id).removeClass("actif");
    $("#shad").removeClass("actif");
    $(".shad").removeClass("actif").removeClass("white");

    if (id === "exit_overlay_OVI") {
        $("#exit_overlay_OVI").hide();
        $("#shad").hide();
    }

    if (id === "ligthbox_send_store_information") {
        var report = $("#ligthbox_send_store_information .report");

        report.html("");
        report.slideUp();
        send_store_loader("hide");
    }

    if (id === "alertStockBox") {
        setTimeout(() => {
            $(".bloc_add_alert_confirmation").hide();
            $(".bloc_add_alert_form").show();
            if (wShop.$refs.wAlertestockForm) {
                wShop.$refs.wAlertestockForm.reloadBloc += 1;
            }
        }, 1000);
    }

    // Pin lightbox
    if ($(".tag").length) {
        $(".lightbox .close").click(function () {
            const closeBtn = $(this).closest(".lightbox");
            closeBtn.removeClass("actif");
        });

        $("#shad").on("click", function () {
            $(".tag + .lightbox").removeClass("actif");
        });
    }

    if (id === "sizeguideBox") {
        $("body.product_page").removeClass("no_hoverflow");
    }

    if (id === "availabilityInStore") {
        if ($('#displayAvailableStock').attr('checked')) {
            $('#displayAvailableStock').click();
        }
    }

    if (id === "country_switcher_lightbox") {
        $.ajax({
            url: path_relative_root + "ajax_set_session_country_code.php",
            type: "post",
            data: {value: $('.country_initials').html().toUpperCase()},
            success: function (res) {},
        });
    }
}

function btnLoaderUnloading(btn) {
    "use strict";

    var loader = btn.next(".loader");

    if (loader.length > 0) {
        setTimeout(function () {
            loader.removeAttr("style").parent().removeClass("loading");
        }, 200);
    }
}

/* ------------------------------ STORE LOCATOR ------------------------------ */

// Creation d'un bloc correspondant a un marqueur sur la liste laterale
function creerLigneListeV2(cpt, marker, mapsMarker, google) {
    let id = marker.getAttribute('magasin_id');
    let magasinId = marker.getAttribute('magasin_id');
    let nom = marker.getAttribute("nom");
    let adresse = marker.getAttribute("adresse");
    let ville = marker.getAttribute("ville");
    let cp = marker.getAttribute("cp");
    let pays = marker.getAttribute("pays");
    if (cp.length === 4 && pays === 'France') {
        cp = '0' + cp;
    }

    // STOCK
    let stock = marker.getAttribute('stock');
    let stock_quantity = marker.getAttribute('stock_quantity');
    let stockStatus = marker.getAttribute('stock-status');

    let clientId = marker.getAttribute('client_id');
    let favorite = marker.getAttribute('favorite');
    let beContacted = marker.getAttribute('contact_by_store');
    let url = marker.getAttribute("url");
    let telephone = marker.getAttribute('tel');
    let lat = parseFloat(marker.getAttribute("lat"));
    let lng = parseFloat(marker.getAttribute("lng"));
    let distance = 0;
    if (marker.getAttribute('distance')) {
        distance = parseFloat(marker.getAttribute('distance'));
    }

    // SCHEDULE
    let dataCurrentlyOpen = getCurrentlyOpen(marker);
    let currently_open = dataCurrentlyOpen.currently_open;
    let horaire_today = dataCurrentlyOpen.horaire_today;

    var li = document.createElement("li");
    li.id = id;
    li.dataset.lng = lng;
    li.dataset.lat = lat;

    li.className = "elem-list-store";

    if (lat != "" && lng != "" && !$("body.product_page").length) {
        li.setAttribute("onclick", "geolocGoto('" + lat + "', '" + lng + "')");
    }

    if (favorite == "1") {
        choose_fav = Translator.translate("actual_favorite_store");
    } else {
        choose_fav = Translator.translate("choose_as_favorite_store");
    }

    /***** Product stock infos *****/
    if (stock_quantity == "undefined" || stock_quantity == "") {
        stock_status_msg = "unknow_stock";
    } else {
        var in_stock = stock_quantity >= 6 && stock_quantity <= 9999;
        var limited_stock = stock_quantity >= 1 && stock_quantity <= 5;
        var not_in_stock = stock_quantity == 0;
        var to_be_confirmed_stock = stock_quantity == 10000;
        var can_be_ordered_stock = stock_quantity == 11000;

        var stock_status_msg = "";
        if (in_stock) {
            stock_status_msg = "in_stock";
        }
        if (limited_stock) {
            stock_status_msg = "limited_stock";
        }
        if (not_in_stock) {
            stock_status_msg = "not_in_stock";
        }
        if (to_be_confirmed_stock) {
            stock_status_msg = "to_be_confirmed_stock";
        }
        if (can_be_ordered_stock) {
            stock_status_msg = "can_be_ordered_stock";
        }
    }

    var info_horaire_today = !horaire_today
        ? Translator.translate("store_closed")
        : horaire_today;
    var class_horaire_today = currently_open ? "store_open" : "store_closed";
    var ligneListe =
        '<div class="elem_list_contents">' + '<div class="nom_store">';
    if (distance) {
        ligneListe +=
            '<h2 data-gp-noloc="node" class="title">' +
            nom +
            '<p class="distance">' +
            "(" +
            distance +
            "km)" +
            "</p></h2>";
    } else {
        ligneListe += '<h2 data-gp-noloc="node" class="title">' + nom + "</h2>";
    }
    ligneListe += "</div>" + '<div class="content_store">';

    if ($("body.product_page").length) {
        ligneListe += `<div class="detail_store" onclick="location.href = '${path_relative_root + url
        }'">`;
    } else {
        ligneListe += '<div class="detail_store">';
    }
    ligneListe +=
        '<div data-gp-noloc="subtree" class="col-1">' +
        '<span class="rue_store">' +
        adresse.toLowerCase() +
        "</span>" +
        '<span class="ville_store">' +
        cp +
        " " +
        ville.charAt(0).toUpperCase() +
        ville.slice(1).toLowerCase() +
        " - " +
        '<span class="pays_store">' +
        pays +
        "</span>" +
        "</span>" +
        '<span class="tel_store">' +
        telephone +
        "</span></div>";

    var is_page_product = $("body.product_page").length == 1;

    if (
        (info_horaire_today !== "" && currently_open) ||
        (!currently_open && horaire_today)
    ) {
        ligneListe +=
            '<div class="col-2"><p class="horaire_today puce_' +
            class_horaire_today +
            '">' +
            info_horaire_today +
            "</p></div>";
    }

    let clickAndGo = marker.getAttribute('click_and_go');
    let clickAndCollect = marker.getAttribute('click_and_collect');
    if ((clickAndGo && clickAndGo === "1") || (clickAndCollect && clickAndCollect === "1")) {
        ligneListe += '<p class="clickandgo_withdrawal">' +
            '<span class="picto_withrawal"></span>' +
            Translator.translate('click_and_go_withdrawal') +
            '</p>';
    }

    isFavorite = favorite ? "favorite_store_js" : "";
    ligneListe +=
        '<a href="javascript:;" class="addfavorite" id="store' +
        magasinId +
        '" onclick="addToMyFavorite(event, \'' +
        magasinId +
        "', '" +
        clientId +
        "', '" +
        favorite +
        "', '" +
        escape(info_horaire_today) +
        "','" +
        currently_open +
        "','" +
        escape(horaire_today) +
        "','" +
        class_horaire_today +
        "','" +
        stock +
        "','" +
        stockStatus +
        "'); return false;\">";
    ligneListe +=
        '<span class="choose_fav_label" id="favShop-' +
        magasinId +
        '"><span class="' +
        isFavorite +
        '">' +
        choose_fav +
        "</span></span></a>";

    ligneListe += "</div>";
    if (document.getElementById("produit_id")) {
        /***** Product stock infos msg *****/
        if (stock != "undefined") {
            ligneListe +=
                '<p class="stock_status ' +
                stock_status_msg +
                '">' +
                Translator.translate(stock_status_msg + "_msg") +
                "</p>";
        }
    }
    if (is_page_product) {
        if (beContacted == 1) {
            if ($("body.product_page.mobile").length) {
                ligneListe +=
                    '<div class="availableTxt store_more" onclick="handleChangeMobile(' +
                    id +
                    ')">' +
                    "<span>" +
                    txt_available_mag +
                    "</span>" +
                    "</div>" +
                    "</div>" +
                    "</div>";
            } else {
                var nom_mag = nom.replace(/'/g, "\\'");
                ligneListe +=
                    '<div class="availableTxt store_more" onclick="handleChange(\'' +
                    id +
                    "','" +
                    nom_mag +
                    "')\">" +
                    "<span>" +
                    txt_available_mag +
                    "</span>" +
                    "</div>" +
                    "</div>" +
                    "</div>";
            }
        } else {
            ligneListe += "</div>" + "</div>";
        }
    }

    if (!is_page_product) {
        ligneListe += '<div class="store_more"><a onclick="triggerStoreDatalayerPush(' + id + ')" href="' + path_relative_root + url + '">' + Translator.translate('afficher_horaires') + '</a>'
            + '</div>';
    }

    ligneListe += "</div>" + "</div>" + "</div>";

    li.innerHTML = ligneListe;

    li.addEventListener("click", function () {
        google.maps.event.trigger(mapsMarker, "click");
    });

    return li;
}
function creerMarqueurV2(cpt, marker, point) {
    let nom = marker.getAttribute("nom");
    let adresse = marker.getAttribute("adresse");
    let ville = marker.getAttribute("ville");
    let cp = marker.getAttribute("cp");
    let pays = marker.getAttribute("pays");
    if (cp.length === 4 && pays === 'France') {
        cp = '0' + cp;
    }

    var url = marker.getAttribute("url");
    var telephone = marker.getAttribute('tel');
    var email = marker.getAttribute('email');
    var site = marker.getAttribute('site');

    let magasin_id = marker.getAttribute('magasin_id');
    let distance = 0;
    if (marker.getAttribute('distance')) {
        distance = parseFloat(marker.getAttribute('distance'));
    }

    // SCHEDULE
    let dataCurrentlyOpen = getCurrentlyOpen(marker);
    let horaire = dataCurrentlyOpen.horaire;
    let currently_open = dataCurrentlyOpen.currently_open;
    let horaire_today = dataCurrentlyOpen.horaire_today;

    var img = path_relative_root + "img/maps/marker.svg";
    var http = new RegExp("^http://", "g");

    const markerImage = document.createElement("img");
    markerImage.src = img;

    var marqueur = new google.maps.marker.AdvancedMarkerElement({
        position: point,
        content: markerImage,
    });

    marqueur.magasin_id = magasin_id;
    nom = $.trim(nom);
    adresse = $.trim(adresse);
    ville = $.trim(ville);
    cp = $.trim(cp);
    pays = $.trim(pays);
    horaire = $.trim(horaire);
    telephone = $.trim(telephone);
    email = $.trim(email);
    site = $.trim(site);
    distance = Math.round(distance);

    var info_horaire_today = !horaire_today ? "" : horaire_today;
    var class_horaire_today = currently_open ? "store_open" : "store_close";
    var currently_open_info = currently_open
        ? Translator.translate("store_opened")
        : Translator.translate("store_closed");

    let ligneListe = `
        <div class="info_popup">
            <div class="name">
                <a href="${url}">${nom}</a>
                ${distance ? `<span class="dist">(${distance} km)</span>` : '</div>'}

    `;

    ligneListe += `<div class="adresse">
        ${adresse.toLowerCase()}<br />
        ${cp + " " + ville.toLowerCase()}<br />
        ${pays.toLowerCase()}
    </div>`;

    if (telephone != "") {
        ligneListe += `<div class="coord">${telephone}</div>`;
    }

    if (site != "") {
        if (!http.test(site)) {
            ligneListe += `<a href="http://${site}" target="_blank">${site}</a>`;
        } else {
            ligneListe += `<a href="${site}" target="_blank">${site}</a>`;
        }
    }

    if (horaire != "") {
        if (class_horaire_today == "store_open") {
            ligneListe += `<div class="horaire_title">
                <span class="${class_horaire_today}">${currently_open_info}</span>
                ${info_horaire_today}
                </div>
            <div class="horaire_info">
                ${horaire}
            </div>`;
        } else {
            //If closed we don't show "info_horaire_today" since it displays "Fermer Fermé"
            ligneListe += `<div class="horaire_title">
                <span class="${class_horaire_today}">${currently_open_info}</span>
            </div>`;
        }
    }

    // Tooltip more infos & go to store link
    ligneListe += `<div class="store_localisation_container">
        <div class="btn_voir_magasin go_to_store"><a class="geolocalisation_link" target="_blank" href="https://maps.google.fr/maps?daddr=${point.lat()},${point.lng()}">
            ${Translator.translate("go_to_store")}</a>
        </div>
        <div class="btn_voir_magasin">
            <a href="${url}">
                ${Translator.translate("voir_magasin")}
            </a>
        </div>
    </div>`;

    google.maps.event.addListener(marqueur, "click", function () {
        // selected store coordinates
        var storePosition = new google.maps.LatLng(point.lat(), point.lng());
        // center map on marker
        maCarte.setCenter(storePosition);
        // map animation on marker switch
        maCarte.panTo(storePosition);

        if (!infowindow) {
            infowindow = new google.maps.InfoWindow();
            infowindow.setContent(ligneListe);
            infowindow.open(maCarte, marqueur);
        } else {
            infowindow.setContent(ligneListe);
            infowindow.open(maCarte, marqueur);
        }
    });

    var detail_store_panel = document.getElementById("store_id_dataLayer");
    detail_store_panel.textContent = magasin_id;

    markersArray.push(marqueur);

    return marqueur;
}

function addToMyFavorite(event,
    magasin_id,
    client_id,
    favorite,
    info_horaire_today,
    currently_open,
    horaire_today,
    class_horaire_today,
    stock,
    stockStatus
) {
    event.stopPropagation();
    if (client_id == 0) {
        alert(
            '<div class="box_txt_wishlist selected_mag"><h2>' +
            Translator.translate("add_store_login_error_title") +
            "</h2><br>" +
            Translator.translate("add_store_login_error_text") +
            '<br><button class="button primary" onclick="favStoreRedirectLogin()">' +
            Translator.translate("vgt_connexion") +
            " </button></div>"
        );
    } else {
        var act = "add";

        $.ajax({
            url: path_relative_root + "ajax_manage_favorite_store.php",
            type: "post",
            dataType: "html",
            data:
                "act=" +
                act +
                "&magasin_id=" +
                magasin_id +
                "&client_id=" +
                client_id,
            success: function (response) {
                response = JSON.parse(response);
                var getCustomerFavoriteStore = document.querySelector(
                    "#customerFavoriteStore"
                );
                var customerFavoriteStore = false;
                if (getCustomerFavoriteStore) {
                    customerFavoriteStore = customerFavoriteStore.value;
                }
                var shopName = document.querySelector(".mag_name_fav");
                var shopStock = document.querySelector(".mag_stock_fav");
                var shopHours = document.querySelector(".mag_hours");
                var shopTown = document.querySelectorAll(".mag_ville");
                var shopStreet = document.querySelector(".mag_rue");
                var shopCountry = document.querySelector(".mag_pays");
                var shopCp = document.querySelector(".mag_cp");

                var noStoreSelected =
                    document.querySelector("#no_store_selected");
                var noStoreSelectedHidden = document.querySelector(
                    "#no_store_selected_hidden"
                );

                var shopList = document.querySelector(".liste_distributeur");

                var customerHeartFav = document.querySelector(
                    "#heartFav-" + magasin_id
                );
                var allHeartFav = document.querySelectorAll(".heartFav");

                var currentFavStore =
                    document.querySelector("#currentFavStore");
                var hiddenProductFavStore = document.querySelector(
                    "#hiddenProductFavStore"
                );
                var noFavShop = document.querySelector("#noFavShop");

                if (allHeartFav) {
                    for (var i = 0; i < allHeartFav.length; i++) {
                        allHeartFav[i].className = "heartFav";
                    }
                }
                if (hiddenProductFavStore && noFavShop) {
                    noFavShop.style.display = "none";
                    hiddenProductFavStore.style.display = "flex";
                }

                if (customerHeartFav) {
                    customerHeartFav.className = "heartFav";
                    customerHeartFav.className = "selected";
                }

                if (shopList) {
                    shopList.className += " withfav";
                }
                if (
                    noStoreSelected &&
                    noStoreSelectedHidden &&
                    !currentFavStore
                ) {
                    noStoreSelected.style.display = "none";
                    noStoreSelectedHidden.style.display = "block";
                }

                if (shopName) {
                    shopName.innerHTML = response.store.magasin_nom;
                }

                if (shopTown) {
                    for (var i = 0; i < shopTown.length; i++) {
                        var town = shopTown[i];
                        town.innerHTML = response.store.magasin_ville;
                    }
                }
                if (shopStreet) {
                    shopStreet.innerHTML = response.store.magasin_adresse;
                }
                if (shopCp) {
                    shopCp.innerHTML = response.store.magasin_cp;
                }
                if (shopCountry) {
                    shopCountry.innerHTML = response.store.magasin_pays;
                }
                if (stock != "null") {
                    shopStock.innerHTML = Translator.translate(
                        stock.slice(0, -3)
                    );
                    shopStock.setAttribute("data-status", stockStatus);
                }

                if (shopHours) {
                    if (
                        (info_horaire_today !== "" && currently_open) ||
                        (!currently_open && horaire_today)
                    ) {
                        shopHours.innerHTML =
                            '<span class="horaire_today"><span class="puce ' +
                            unescape(class_horaire_today) +
                            '"></span> ' +
                            unescape(info_horaire_today) +
                            "</span>";
                    } else {
                        shopHours.innerHTML = "";
                    }
                }

                var storeClient = document.getElementById(
                    "favShop-" + magasin_id
                );
                var allStore =
                    document.getElementsByClassName("choose_fav_label");
                var countAllStore = allStore.length;

                for (var i = 0; i < countAllStore; i++) {
                    allStore[i].innerHTML =
                        "<span>" +
                        Translator.translate("choose_as_favorite_store") +
                        "</span>";
                }

                if (response.status == "add") {
                    storeClient.innerHTML =
                        '<span class="favorite_store_js">' +
                        Translator.translate("actual_favorite_store") +
                        "</span>";
                } else if (response.status == "delete") {
                    storeClient.innerHTML =
                        "<span>" +
                        Translator.translate("choose_as_favorite_store") +
                        "</span>";
                }

                if ($('#pdvBox').hasClass("deployed") && act == "add") {
                    $('#pdvBox').removeClass("deployed");
                    location.reload();
                }
            },
        });
    }
    return false;
}

// popup PDV
function showpdv() {
    var shade, modbox;
    $.ajax({
        type: "post",
        url: path_relative_root + create_link("ajax_search_shop"),
        success: function (res) {
            if (res) {
                shade = document.querySelector("#shad.modal_shade");
                modbox = document.getElementById("pdvBox");

                // Make sure modbox will show on top of shad
                $(shade).after(modbox);

                // Inject store locator into modbox
                $(".store_locator").html(res);

                // magasin_gmap.js
                initialize();

                // Show modbox and make sure closing routine won't fire more than once

                $(shade).off("click", closepdv);
                $(modbox).addClass("deployed");
                $(shade).addClass("actif");
                $(shade).on("click", closepdv);
                $("#pdv_load").removeClass("loading");
            }
        },
    });
}

/* ------------------------------ FAVORITE STORE ------------------------------ */
function addToMyFavorites() {
    var is_favorite_elem = document.getElementById("is_favorite");

    var self = $(this);
    var magasin_id = self.attr("data-magasinid");
    var client_id = self.attr("data-clientid");
    var action = self.attr("data-action");

    // Si l'action est de détruire alors on est dans favorites_stores et on souhaite supprimer le bloc en entier
    if (action == "destroy") {
        var act = "del";
    } else {
        // On est dans store_details et on doit recupérer le statut actuel du magasin pour savoir si on doit le supprimer ou l'ajouter
        if (is_favorite_elem.value == "1") {
            var act = "del";
        } else {
            var act = "add";
        }
    }

    $.ajax({
        url: path_relative_root + "ajax_manage_favorite_store_detail.php",
        type: "post",
        dataType: "html",
        data: "act=" + act + "&magasin_id=" + magasin_id,
        success: function (response) {
            if (response) {
                // Destruction du bloc
                if (action == "destroy") {
                    self.slideUp("slow", function () {
                        self.remove();
                    });
                } else {
                    if (act == "add") {
                        var libelle =
                            "<span>" +
                            Translator.translate("delete_to_favorites") +
                            "</span>";

                        is_favorite_elem.value = 1;
                    } else {
                        var libelle =
                            "<span>" +
                            Translator.translate("add_to_favorites") +
                            "</span>";

                        is_favorite_elem.value = 0;
                    }
                    self.html(libelle);
                }
            }
        },
    });
}

/**
 * After ajax called in basket (also called in _app)
 */
function updateCartElements() {
    var cartArticles = $(".cart_main_table.basket");
    var cartWishlist = $(".cart_main_table.wishlist");
    var AssocPosition = cartWishlist.length ? cartWishlist : cartArticles;
    var cartAssocSwiper = $(".cartAssocSwiper");
    var cartPush = $(".push_container");

    // Placement of associations just after products/wishlist
    $(".cartAssociations").insertAfter(AssocPosition);
    // Placement of push right after cart right summary
    cartPush.insertAfter($("#right_col_sticky"));

    /**
     * Cart associations slider init
     */
    if (cartAssocSwiper.length) {
        new Swiper(".cartAssocSwiper", {
            slidesPerView: 3.4,
            spaceBetween: 15,
            pagination: {
                el: ".cartAssocPagination",
                clickable: true,
                type: "bullets",
            },
        });

        setTimeout(function () {
            $(".cartAssociations").addClass("appear");
        }, 300);
    }

    if ($(".cart_product_modify .basketToWishlist").hasClass("clicked")) {
        $(".cart_product_modify .basketToWishlist").removeClass("clicked");
        setTimeout(() => {
            window.location.reload();
        }, 100);
    }
}

function createCookie(name, value, days, isSecure, domain, sameSite) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var expires = "; expires=" + date.toGMTString();
    } else {
        var expires = "";
    }

    var secure = typeof isSecure != 'undefined' && isSecure ? ";secure" : "";
    var domain = typeof domain != 'undefined' && domain != '' ? ";domain=" + domain : "";
    var sameSite = typeof sameSite != 'undefined' ? ";samesite:" + sameSite : "";

    document.cookie = name + "=" + value + expires + "; path=/" + secure + domain + sameSite;
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
}

/**
 * Toggle product details in cart right column
 */
$(".total_produit").on("click", function () {
    $(this).toggleClass("open");
    $(".total_produit_dropdown").slideToggle();
});

// Fonction utilisée quand l'utilisateur indique un lieu
function geocodeAdresse() {
    // On affiche le loader
    displayLoader("hide");

    // Sans provider le geocodeur ne rappelle jamais son callback : la liste des
    // boutiques ne serait jamais demandee. Le serveur sait la renvoyer sans
    // coordonnees, on l'interroge directement. (WP-35207)
    if (typeof storeLocatorMapsReady === "function" && !storeLocatorMapsReady()) {
        rechercheProximite();

        return;
    }

    var adresse = "";

    adresse = document.getElementById("search_cp").value.trim();

    // Cas special pour nancy il nous envoie aux US!!!
    if (search_exceptions.includes(adresse)) {
        adresse += " france";
    }

    if (zipcode_rex.test(adresse)) {
        adresse += ", France";

        document.getElementById("search_cp").value += ", France";
    }

    if (geocodeur != "undefined") {
        geocodeur = new google.maps.Geocoder();
    }

    if (adresse == "") {
        adresse = get("search_cp");
        if (typeof adresse == "undefined") {
            adresse = "";
        }
    }

    geocodeur.geocode(
        {
            address: adresse,
        },
        function (results, status) {
            $(".txt_alert#error_loc").remove();
            // Si l'utilisateur ne saisit rien on se remet à la position initiale (on remet la premiere carte et tous les magasins)
            if (adresse === "") {
                if ($("#retailers_map").length) {
                    initSearch();
                    clusterer = new MarkerClusterer(
                        maCarte,
                        markers,
                        mcOptions
                    );

                    boundChanched(maCarte, markersArray);
                    markers = [];
                }

                // On va rechercher tous les magasins
                rechercheProximite();
            } else if (type_call == "select_pays") {
                rechercheProximite();
            } else if (status == google.maps.GeocoderStatus.OK) {
                rechercheProximite(results[0]);
            } else {
                displayLoader("show");
                let error =
                    "<div class='txt_alert' id='error_loc'>" +
                    adresse +
                    " " +
                    Translator.translate("txt_introuvable") +
                    "</div>";
                $(error).insertAfter($("div.wrap_fields"));
            }
        }
    );
}

/* ------------------------------ TAG ------------------------------ */

// Add class on module tags to improve lightbox positioning on hover
function tagPositionForHomeModule() {
    // stores the tag container in each module in an array
    var moduleArray = [
        {
            module: ".cms-page-module.image-module.images2",
            wrapper: ".blocImage",
        },
        {
            module: ".cms-page-module.slider-cover-module.cover-look",
            wrapper: ".cms-page-columns-container",
        },
        {
            module: ".cms-page-module.text-image-4",
            wrapper: ".cms-page-columns-container",
        },
        {
            module: ".cms-page-module.image-module.images3",
            wrapper: ".blocImage",
        },
        {
            module: ".cms-page-module.image-module.images4",
            wrapper: ".blocImage",
        },
        {
            module: ".cms-page-module.image-module.images5",
            wrapper: ".blocImage",
        },
    ];

    // iteration in each module
    moduleArray.forEach(function (obj) {
        if ($(obj.module).length) {
            var imgWrapper = $(obj.module).find(obj.wrapper);

            var centerPos = imgWrapper.width() / 2;
            var middlePos = imgWrapper.height() / 2;

            // set the tag new position in each module
            imgWrapper.find(".tag").each(function () {
                var tagCenterPos = 7 + parseInt($(this).css("left"));
                var tagMiddlePos = 7 + parseInt($(this).css("top"));

                if (tagCenterPos >= centerPos) {
                    $(this).removeClass("leftPos").addClass("rightPos");
                } else {
                    $(this).removeClass("rightPos").addClass("leftPos");
                }

                if (tagMiddlePos >= middlePos) {
                    $(this).removeClass("topPos").addClass("bottomPos");
                } else {
                    $(this).removeClass("bottomPos").addClass("topPos");
                }
            });
        }
    });
}

/* Recherche bar on press enter button open search bar */
function activateSearchBar() {
    $("#trigger_recherche").click();
}

function mySubmit(pType) {
    $(".cartLoader").addClass("loading");
    var form = document.getElementById("formPanier");

    form.action = create_link("order_basket");

    setTimeout(function () {
        form.submit();
    }, 500);
}

/**
 * Add new payement card in account page
 */
$(document).on(
    "click touch",
    ".account_payment_options .addNewCard",
    function () {
        $(".wrapper_form").removeClass("displayed");
        $("#psp_form").addClass("displayed");
    }
);

function deleteItemFromCart(id, qty) {
    if (
        typeof dataLayer_v3 !== "undefined" &&
        dataLayer_v3 !== "" &&
        dataLayer_v3 !== null &&
        id !== null &&
        id !== undefined
    ) {
        DataLayerTrigger.cart_product_action(
            dl_v3_impressions,
            dlv3_action_fields,
            id,
            "remove_from_cart",
            qty
        );
    }
}

function showElementOfUrlId() {
    const url = window.location.href;
    const urlSegments = url.split("#")[1];

    if (urlSegments) {
        $("html, body").animate(
            {
                scrollTop:
                    $(".switch-controller").offset().top -
                    $("#site_head_wrap").outerHeight() - 40,
            },
            400
        );
        addActiveClass(`[data-filter="${urlSegments}"]`, urlSegments);
    } else if (url.includes("shoe_care")) {
        addActiveClass(`[data-filter="the-golden-rules"]`, "the-golden-rules");
    } else {
        addActiveClass(`[data-filter="les-regles-d-or"]`, "les-regles-d-or");
    }
    window.onload = showElementOfUrlId;
}

function addActiveClass(selector, id) {
    const switchBtn = document.getElementById(id);

    if (switchBtn) {
        $(".switch-btn").removeClass("active");

        switchBtn.classList.add("active");
        const switchSlider = document.querySelector(
            '.switch-slider[data-filter="' + id + '"]'
        );
        $(".switch-slider").removeClass("active");
        switchSlider.classList.add("active");
    }
}

function fadeInShowClass(scrollBarPosition) {
    if (window.pageYOffset >= scrollBarPosition) {
        $('.svg-box').addClass('fadeInShow')
    } else {
        $('.svg-box').removeClass('fadeInShow')
    }
}

if ($('.satellite_conseils_entretien')) {
    window.addEventListener('scroll', function () {
        if (window.innerWidth >= 1024 && window.innerWidth <= 1400) {
            fadeInShowClass(650);
        } else if (window.innerWidth > 1400 && window.innerWidth <= 1600) {
            fadeInShowClass(850);
        } else if (window.innerWidth > 1600) {
            fadeInShowClass(1000);
        }
    });
}

/**
 * Truncates a given phrase to a specified maximum length, appending "..." if truncation occurs.
 *
 * @param {string} phrase - The phrase to be truncated.
 * @param {number} maxLength - The maximum allowed length of the returned text.
 *
 * @returns {{ text: string, truncated: boolean }} An object containing the possibly truncated text and a flag indicating if truncation occurred.
 */
function truncatePhrase(phrase, maxLength) {
    phrase = phrase.trim();
    if (phrase.length > maxLength) {
        return {
            text: phrase.substring(0, maxLength - 3) + "...",
            truncated: true
        };
    }
    return { text: phrase, truncated: false };
}

if ($('.product-link').length) {
    const maxLength = 28;

    $('.product-link').each(function() {
        const $link = $(this);

        // Internal function to avoid repeating code
        const handleTruncation = (selector) => {
            const $el = $link.find(selector);
            const text = $el.text().trim();
            const { text: truncated, truncated: isTruncated } = truncatePhrase(text, maxLength);

            $el.text(truncated);
            if (isTruncated) $el.attr('title', text);
        };

        handleTruncation('.sub_title');
        handleTruncation('.sstitre');
    });
}

// Get product data
function getProductDetail(productId) {

    let form = (this instanceof HTMLFormElement) ? this : document.getElementById('prod_info_' + productId);

    var pcolor = form.getValue('idCouleur');
    let val_color = form.getValue(pcolor);

    let psize = form.getValue('idTaille');
    let val_size = form.getValue(psize);

    let data = {
        produitId: productId,
        colorId : val_color,
        sizeId : val_size,
        json: 'json'
    };

    $.ajax({
        url: path_relative_root + 'ajax_product_data.php',
        type: 'get',
        async: true,
        dataType: 'json',
        data: data,
        success: function (res) {

            // Set event ID for product detail dataLayer
            if (typeof(res) == 'object') {
                pushIntoDatalayer(res.dataLayerData.productDetails);
            }
        }
    });
}

function openAlerteStock(id) {
    if (!$('.bloc_add_alert_' + id + ' .alert_stock').hasClass('show')) {
        $('.bloc_add_alert_' + id + ' .alert_stock').addClass('show');
        $('.bloc_add_alert_' + id + ' .bloc_add_alert_form').addClass('show');
        $('.bloc_add_alert_' + id + ' .alert_return').show();
        $('.bloc_add_alert_' + id + ' .bloc_add_alert_form').show();
    }
}

function checkValidityRequestOfReturn() {
    var selectId = $(this).attr('id');
    var selectedValue = $(this).val();

    if (selectId.includes("return_quantity")) {
        valueIdTailleQuantity = selectId.split("return_quantity_")[1];

        if (selectedValue != 0) {
            $('#' + selectId).addClass('choice_locked');
            if (!$('#return_choice_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                $('#return_choice_' + valueIdTailleQuantity).addClass('choice_unlocked_both').prop("disabled", false);
                $('#' + selectId).addClass('choice_unlocked_both');
            }
        } else {
            if ($('#' + selectId).hasClass('choice_locked') && !$('#return_choice_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                $('#' + selectId).removeClass('choice_locked');
                $('#return_choice_' + valueIdTailleQuantity).addClass('choice_unlocked_both');
                $('#' + selectId).addClass('choice_unlocked_both');
                if (document.querySelector('.choice_locked_both')) {
                    $('#return_choice_' + valueIdTailleQuantity).addClass('choice_locked_both');
                    $('#' + selectId).addClass('choice_locked_both');
                    $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_unlocked_both');
                    $('#' + selectId).removeClass('choice_unlocked_both');
                }
            } else if ($('#' + selectId).hasClass('choice_locked') && $('#return_choice_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                $('#' + selectId).removeClass('choice_locked');
                $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_locked');
                $('#return_choice_' + valueIdTailleQuantity).addClass('choice_unlocked_both').prop("disabled", true);
                $('#return_choice_' + valueIdTailleQuantity).val(0);
                $('#' + selectId).addClass('choice_unlocked_both');
                $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_locked_both')
                $('#' + selectId).removeClass('choice_locked_both');
                if (document.querySelector('.choice_locked_both')) {
                    $('#return_choice_' + valueIdTailleQuantity).addClass('choice_locked_both');
                    $('#' + selectId).addClass('choice_locked_both');
                    $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_unlocked_both');
                    $('#' + selectId).removeClass('choice_unlocked_both');
                }
            }
            $('#return_choice_' + valueIdTailleQuantity).removeClass('choice_unlocked_both').prop("disabled", true).val(0);
            $('#' + selectId).removeClass('choice_unlocked_both');
        }
    } else if (selectId.includes("return_choice")) {
        valueIdTailleChoice = selectId.split("return_choice_")[1];
        if (selectedValue != 0) {
            $('#' + selectId).addClass('choice_locked');
            $('#return_quantity_' + valueIdTailleChoice).addClass('choice_locked_both');
            $('#' + selectId).addClass('choice_locked_both');
            $('#return_quantity_' + valueIdTailleChoice).removeClass('choice_unlocked_both');
            $('#' + selectId).removeClass('choice_unlocked_both');

            if ($('#' + selectId).parents('.item_container').is(':nth-last-child(-n+3)')) {
                $('#' + selectId).parents('.item_container').addClass('trigger_scroll');
            } else {
                $('.item_container.trigger_scroll').removeClass('trigger_scroll');
            }
        } else {
            if ($('#' + selectId).hasClass('choice_locked') && $('#return_quantity_' + valueIdTailleQuantity).hasClass('choice_locked')) {
                $('#' + selectId).removeClass('choice_locked');
                $('#return_quantity_' + valueIdTailleChoice).addClass('choice_unlocked_both');
                $('#' + selectId).addClass('choice_unlocked_both');
                $('#return_quantity_' + valueIdTailleChoice).removeClass('choice_locked_both');
                $('#' + selectId).removeClass('choice_locked_both');

                if ($('#' + selectId).parents('.item_container').is(':nth-last-child(-n+3)')) {
                    $('#' + selectId).parents('.item_container').addClass('trigger_scroll');
                } else {
                    $('.item_container.trigger_scroll').removeClass('trigger_scroll');
                }
            }
        }
    }

    if (!$('.choice_unlocked_both').length && $('.choice_locked').length) {
        $(".divBtnPrintPdf").show();

        if ($('.trigger_scroll').length) {
            $(".return_products_list").animate({scrollTop: $(".return_products_list")[0].scrollHeight},500);
        }
    } else {
        $(".divBtnPrintPdf").hide();
    }
}

$(document).ready(function () {
    $(".return_products_form select").change(function () {
        var selectedElement = $(this);
        checkValidityRequestOfReturn.call(selectedElement);
    });

    if ($(".player-container-dailymotion").length) {
        initDailymotionVideos();
    }
});

/**
 * Updates the product availability display based on stock data from the server for a specific store.
 *
 * Sends an AJAX POST request to retrieve stock information, then updates the UI to reflect
 * whether the product is unavailable, limited, or available in the selected store.
 *
 * @param {Object} data - The data to send in the AJAX request, typically containing product and store identifiers.
 *
 * @author Stefane DR <sdr@wshop.com>
 */
function updateAvailabilityByStore(data) {
    $.ajax({
        type: 'post',
        data: data,
        url: path_relative_root + 'ajax_get_stock_by_store.php',
        success: function (res) {
            let showSimpleBloc = false;
            let showMultipleBloc = false;
            let stock = res['stock'] || 0;
            let classe, traduction;
            if (stock <= availabilityInStoreStockLevelLow || res?.store?.[0]?.magasin_click_and_go === 0) {
                traduction = Translator.translate('store_locator_product_unavailable')
                classe = '';
                showSimpleBloc = true;
            } else if (stock > availabilityInStoreStockLevelLow && stock <= availabilityInStoreStockLevelMedium) {
                traduction = Translator.translate('store_locator_product_limited')
                classe = 'limited';
                showMultipleBloc = true;
            } else {
                traduction = Translator.translate('store_locator_product_available')
                classe = 'available';
                showMultipleBloc = true;
            }
            if (showSimpleBloc) {
                $("#bloc_availability .disponibility_other_store").show();
                $("#bloc_availability .disponibility_change").hide();
                $("#bloc_availability .disponibility_retire").hide();
            } else if (showMultipleBloc) {
                $("#bloc_availability .disponibility_other_store").hide();
                $("#bloc_availability .disponibility_change").show();
                $("#bloc_availability .disponibility_retire").show();
            }
            $(".clickandgo_product_info .availability").removeClass('limited');
            $(".clickandgo_product_info .availability").removeClass('available');
            $(".clickandgo_product_info .availability").addClass(classe);
            $(".clickandgo_product_info .availability .label_availability").html(traduction);
        }
    });
}


// FUNCTION PUSH INTO DATALAYER
function pushIntoDatalayer(data) {
    if (typeof (data) == 'object') {
        pushToWshopBus(data);
    } else if (typeof (data) == 'string') {
        pushToWshopBus(JSON.parse(data));
    }
}


/**
 * GET dataLayer object data for PINTERST EVENTS
 * @param {string} type
 * @param {string} id
 * @param {string} currency
 */
function getDataLayerObjectInfo(type, id, currency) {
    var impressions = data_layer_products;
    let data = {
        type: type,
        id: id,
        json: 'json'
    };


    var dataInfo = {
        event: "productImpressions",
        ecommerce: {
            currencyCode: currency,
            impressions: [impressions]
        }
    }

    $.ajax({
        url: path_relative_root + 'ajax_object_data.php',
        type: 'get',
        async: true,
        dataType: 'json',
        data: data,
        success: function (res) {
            // Set event ID for product detail dataLayer
            if (typeof (res) == 'object') {
                dataInfo['ecommerce']['event_id'] = res.dataLayerData.event_id;
                pushIntoDatalayer(dataInfo);
            }
        }
    });
}

/*------------------------------ LAZY LOAD IMAGES ------------------------------ */
/**
 * Custom lazy loading for images using Intersection Observer API.
 * This implementation defers the loading of images until they are about to enter
 * the viewport, improving initial page load performance and reducing bandwidth usage.
 */
document.addEventListener('DOMContentLoaded', () => {
    lazyImageLoader(); // custom image lazyloading function
    window.addEventListener('search_success', function () {
        lazyImageLoader(); // custom image lazyloading function
        initializeItemSliders(); // hydrate slider slides of search results (search_index_v2)
    });
});

/**
 * Initializes lazy loading for all images with [is-lazy] and [data-src] attributes.
 */
function lazyImageLoader() {

    /**
     * Loads a lazy image by setting its src from data-src.
     * @param {HTMLImageElement} img - The image element to load.
     */
    const loadingLazy = (img) => {

        const src = img.getAttribute('data-src');
        if (!src) return; // Skip if no data-src attribute

        if(img.src && src) {
            img.removeAttribute('src');
        }

        // Mark image as loaded once it finishes loading
        img.onload = () => img.setAttribute('is-loaded', '');

        // Set the actual image source to trigger loading
        img.src = src;

        // Clean up lazy loading attributes
        img.removeAttribute('data-src');
    };

    /**
     * IntersectionObserver instance to watch for images entering the viewport.
     */
    const io = new IntersectionObserver((entries, obs) => {
        for (const e of entries) {
            if (e.isIntersecting) {
                loadingLazy(e.target); // Load the image
                obs.unobserve(e.target); // Stop observing once loaded
            }
        }
    }, {
        root: null,              // Observe relative to viewport
        rootMargin: '0px 0px',   // No margin - load only when actually in view
        threshold: 0.01,         // Trigger when 1% of image is visible
    });

    // Find all lazy images and start observing them
    document.querySelectorAll('img[is-lazy][data-src]').forEach(img => io.observe(img));
}
// end custom lazy loading for images

function remove_shad() {
    if(!$("body.cart .delivery_lightbox").hasClass('actif')) {
        $('#shad').removeClass('actif');
    }
}

/**
 * [SW-22185] Reorder the "Talon" custom_data filter values in a fixed, business-defined order.
 *
 * Runs on:
 *   - rayon / category pages: wrapper_filters.php tags the wrapper with the filter name
 *     as a class (e.g. `.filter_custom_data.talon`). Rendered once, never rebuilt.
 *   - search page: Vue re-renders on every result; the app dispatches `search_success`
 *     ~500ms after render (see _app/_src/js/vue-app*.js), so hooking that event is
 *     enough — no MutationObserver needed.
 *
 * To change the order, edit TALON_ORDER below. Labels must match the visible <label>
 * text of each option. Items whose label is not in TALON_ORDER keep their original
 * position (they end up at the top, above the reordered ones).
 */
(function () {
    var TALON_ORDER = [
        '0 - 3 cm',
        '3 - 6 cm',
        '6 - 9 cm',
        '9 - 12 cm',
        '12 - 15 cm'
    ];

    function reorderTalonFilter() {
        document.querySelectorAll('.filter_custom_data').forEach(function (wrapper) {
            // Fast path (rayon): the server already tags the wrapper with the filter slug.
            // Fallback (search Vue): match the legend text.
            if (!wrapper.classList.contains('talon')) {
                var legend = wrapper.querySelector('.filter_name');
                if (!legend || legend.textContent.trim().toLowerCase() !== 'talon') {
                    return;
                }
            }

            // The container that holds .custom_data items uses a different class in
            // each of the 4 layouts (ul.filter_options / div.selected_options / …), so
            // derive it from the first item's parent — layout-agnostic.
            var firstItem = wrapper.querySelector('.custom_data');
            if (!firstItem || !firstItem.parentNode) {
                return;
            }
            var container = firstItem.parentNode;

            var byLabel = {};
            container.querySelectorAll(':scope > .custom_data label').forEach(function (lbl) {
                byLabel[lbl.textContent.trim()] = lbl.closest('.custom_data');
            });

            // appendChild moves the existing node — Vue bindings, jQuery listeners
            // and checkbox state are preserved.
            TALON_ORDER.forEach(function (label) {
                if (byLabel[label]) {
                    container.appendChild(byLabel[label]);
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', reorderTalonFilter);
    } else {
        reorderTalonFilter();
    }
    window.addEventListener('search_success', reorderTalonFilter);
})();

function initializeItemSliders() {
    const galleries = document.querySelectorAll('.productSwiper');
    if (!galleries.length) return;

    const io = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                if (entry.target.classList.contains('no-slider')) {
                    // no Swiper instance here, so lock the nav buttons manually
                    entry.target.querySelectorAll('.productSwiper-button').forEach((btn) => {
                        btn.classList.add('swiper-button-lock');
                    });
                    // no Swiper: hydrate data-src directly so rollover image loads
                    entry.target.querySelectorAll('img[data-src]').forEach((img) => {
                        img.setAttribute('src', img.getAttribute('data-src'));
                        img.removeAttribute('data-src');
                        img.setAttribute('is-loaded', '');
                    });
                    entry.target.querySelectorAll('source[data-srcset]').forEach((source) => {
                        source.setAttribute('srcset', source.getAttribute('data-srcset'));
                        source.removeAttribute('data-srcset');
                        source.setAttribute('is-loaded', '');
                    });
                } else {
                    initRayonItemSlider(entry.target);
                }
                observer.unobserve(entry.target);
            });
        },
        { root: null, threshold: 0, rootMargin: '100px 0px' }
    );

    galleries.forEach((g) => io.observe(g));
}

function initRayonItemSlider(gallery) {
    if (gallery.classList.contains('swiper-initialized')) return;

    const itemSlider = new Swiper(gallery, {
        loop: true,
        roundLengths: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: gallery.querySelector('.rollover_rayonsNext'),
            prevEl: gallery.querySelector('.rollover_rayonsPrev'),
        },
    });

    hydrateActiveSlide(gallery);
    itemSlider.on('slideChange', () => hydrateActiveSlide(gallery));
}

// Hydrate tout slide actuellement visible (actif + adjacents si slidesPerView > 1, ex. #jqzoom
// qui en affiche 2), d'après les classes posées par Swiper lui-même (fiable même en loop, où
// l'actif peut être un clone) plutôt que de recalculer les index à la main.
function hydrateActiveSlide(gallery) {
    gallery.querySelectorAll('.swiper-slide-active, .swiper-slide-next, .swiper-slide-visible').forEach(hydrateSlide);
}

function hydrateSlide(slide) {
    // Pas de dépendance à la classe 'imgProd' : réutilisé aussi par #jqzoom (classe 'img_large').
    slide.querySelectorAll('img').forEach((img) => {
        // TwicPics only picks up "data-twic-src" on elements inserted into the DOM,
        // it ignores attributes added to an already-existing node, so the placeholder
        // image is replaced with a clone carrying the real attribute instead of mutating it in place.
        const twicSrc = img.getAttribute('data-twic-src-slider');
        if (twicSrc) {
            const loadedImg = img.cloneNode(true);
            loadedImg.setAttribute('data-twic-src', twicSrc);
            loadedImg.removeAttribute('data-twic-src-slider');
            loadedImg.removeAttribute('is-slider');
            img.replaceWith(loadedImg);
            return;
        }

        const ds = img.getAttribute('data-src');
        if (!ds) return;
        img.setAttribute('src', ds);
        img.removeAttribute('data-src');
        img.setAttribute('is-loaded', '');

        const srcset = img.getAttribute('data-srcset');
        if (!srcset) return;
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
    });

    slide.querySelectorAll('source').forEach((source) => {
        const ds = source.getAttribute('data-srcset');
        if (!ds) return;
        source.setAttribute('srcset', ds);
        source.removeAttribute('data-srcset');
        source.setAttribute('is-loaded', '');
    });
}